import * as i0 from '@angular/core';
import { Injectable, Inject, SecurityContext, Pipe, ErrorHandler, EventEmitter, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@angular/common/http';
import { HttpHeaders, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import * as i2 from '@angular/platform-browser';
import * as _ from 'lodash';
import { isNil, get, forEach, isObject, set, startsWith } from 'lodash';
import * as Raven from 'raven-js';
import { from, BehaviorSubject, of, forkJoin, throwError, timer, ReplaySubject, combineLatest, Observable } from 'rxjs';
import { __decorate, __metadata } from 'tslib';
import 'reflect-metadata';
import { defaultMetadataStorage } from 'class-transformer/storage';
import { memoize, MemoizeAll, Memoize } from 'lodash-decorators';
import { Expose, plainToClass } from 'class-transformer';
import { filter, distinctUntilChanged, map, tap, bufferTime, debounceTime, takeUntil, mergeMap, share, take, catchError, switchMap, retryWhen, finalize, flatMap } from 'rxjs/operators';
import * as Fuse from 'fuse.js';
import * as CryptoJS from 'crypto-js';
import * as i1$2 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as jsforce from 'jsforce/build/jsforce.min.js';
import * as querystring from 'querystring';
import { ExposeMetadata } from 'class-transformer/metadata/ExposeMetadata';
import * as parser from 'xml-js';

class Configuration {
    constructor() {
        this.type = 'Salesforce';
        this.authenticationEndpoint = '';
        this.defaultCountry = 'US';
        this.defaultLanguage = 'en-US';
        this.enableErrorLogging = true;
        this.enableErrorReporting = true;
        this.enableMultiCurrency = false;
        this.enableErrorPrinting = true;
        this.enableQueryLogs = true;
        this.enablePerformanceLogs = true;
        this.defaultCurrency = 'USD';
        this.bufferTime = 200;
        this.maxBufferSize = 10;
        this.disableBuffer = false;
        this.disableCache = false;
        this.encryptResponse = true;
        this.productIdentifier = 'Id';
        this.cartRetryLimit = 10;
        this.debounceTime = 200;
        this.subqueryLimit = 20;
        this.runTimeDebugMode = false;
        this.useIndexedDB = false;
        this.storefront = null;
        this.queryDepth = 2;
        this.expandDepth = 10;
        this.hashRouting = false;
        this.pricingMode = 'default';
        this.pricingFallback = false;
        this.skipPricing = true;
        this.skipRules = false;
    }
}
var PlatformConstants;
(function (PlatformConstants) {
    PlatformConstants["KEY"] = "credentials";
    PlatformConstants["ACCESS_TOKEN"] = "access_token";
    PlatformConstants["REFRESH_TOKEN"] = "refresh_token";
    PlatformConstants["USER_INFO"] = "user_info";
    PlatformConstants["SV"] = "u/Gu5posvwDsXUnV5Zaq4g==";
    PlatformConstants["IV"] = "5D9r9ZVzEYYgha93/aUK2w==";
    PlatformConstants["PREFERRED_LANGUAGE"] = "preferred_language";
    PlatformConstants["TRANSLATION_LABELS"] = "translation_labels";
    PlatformConstants["TOKEN_EXPIRED"] = "token_expired";
})(PlatformConstants || (PlatformConstants = {}));

let vfConfig = window.sv || {};
class ConfigurationService {
    constructor(config, platformLocation) {
        this.config = config;
        this.platformLocation = platformLocation;
        this._config = Object.assign({}, new Configuration(), config);
    }
    proxyEndpoint() {
        const endpoint = this.endpoint();
        const proxy = this.get('proxy');
        if (proxy && proxy.endsWith('/'))
            return this.get('proxy') + endpoint;
        else
            return ((proxy != null) ? proxy + '/' : '') + endpoint;
    }
    endpoint() {
        return this.get('endpoint') != null && this.get('endpoint') !== 'null' ? this.get('endpoint') : `https://${window.location.hostname}${window.location.pathname}`;
    }
    resourceLocation() {
        let location = `${window.location.protocol}//${window.location.host}${_.get(vfConfig, 'resource', this.platformLocation.getBaseHrefFromDOM())}`;
        return !_.endsWith(location, '/') ? `${location}/` : location;
    }
    get(key, defaultValue) {
        return _.get(this._config, key, defaultValue);
    }
    platform() {
        return _.get(this._config, 'type', 'Salesforce');
    }
}
ConfigurationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConfigurationService, deps: [{ token: 'configuration' }, { token: i1.PlatformLocation }], target: i0.ɵɵFactoryTarget.Injectable });
ConfigurationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConfigurationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ConfigurationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: Configuration, decorators: [{
                    type: Inject,
                    args: ['configuration']
                }] }, { type: i1.PlatformLocation }]; } });

let _windowConfig$2 = window.sv;
class ImagePipe {
    constructor(configurationService, dss) {
        this.configurationService = configurationService;
        this.dss = dss;
        this.url = null;
    }
    transform(attachmentId, asset = true, defaultImage = true, productId) {
        const random = Math.floor(Math.random() * 50) + 1;
        if (this.url)
            return this.url;
        else {
            const absoluteUrlRegExp = new RegExp('^(?:[a-z]+:)?//', 'i');
            let endpoint = this.configurationService.endpoint();
            const resource = this.configurationService.resourceLocation();
            let defaultImageSrc = (this.configurationService.get('defaultImageSrc') != null) ? this.configurationService.get('defaultImageSrc') : './assets/images/placeholder.png';
            defaultImageSrc += `?random=${random}`;
            this.url = (asset) ? resource + defaultImageSrc : defaultImageSrc;
            let _temp = this.url;
            if (attachmentId && attachmentId.indexOf('/') === 0)
                _temp = (asset) ? resource + attachmentId : attachmentId;
            else if (attachmentId && absoluteUrlRegExp.test(attachmentId))
                _temp = attachmentId;
            else if (attachmentId && attachmentId.indexOf('/') > 0 && this.configurationService.get('type') === 'AIC') {
                _temp = `https://${this.configurationService.get('storageAccount')}.blob.core.windows.net/tenant${this.configurationService.get('tenantId')}-public/${attachmentId}`;
                defaultImage = false;
            }
            else if (attachmentId && attachmentId.indexOf('/') > 0)
                _temp = (asset) ? resource + `${!_.endsWith(resource, '/') ? '/' : ''}` + attachmentId : attachmentId;
            else if (attachmentId && productId && this.configurationService.get('type') === 'AIC') {
                _temp = `https://${this.configurationService.get('storageAccount')}.azureedge.net/tenant${this.configurationService.get('tenantId')}-public/productinformation/${productId}/attachments/${attachmentId}`;
                defaultImage = false;
            }
            else if (attachmentId)
                _temp = endpoint + '/servlet/servlet.FileDownload?file=' + attachmentId;
            _temp = _temp.substring(_temp.lastIndexOf('http'));
            if (defaultImage)
                this.checkImage(_temp, () => this.url = this.dss.sanitize(SecurityContext.URL, _temp), () => this.url = this.dss.sanitize(SecurityContext.URL, defaultImageSrc));
            else
                this.url = _temp;
            return this.dss.sanitize(SecurityContext.URL, this.url);
        }
    }
    checkImage(url, success, failure) {
        let img = new Image(), loaded = false, errors = {}, errored = false;
        // Run only once, when `loaded` is false. If `success` is a
        // function, it is called with `img` as the context.
        img.onload = () => {
            if (loaded) {
                return;
            }
            loaded = true;
            if (success && success.call) {
                success.call(img);
            }
        };
        // Run only once, when `errored` is false. If `failure` is a
        // function, it is called with `img` as the context.
        img.onerror = () => {
            if (errored) {
                return;
            }
            errors[url] = errored = true;
            if (failure && failure.call) {
                failure.call(img);
            }
        };
        // If `url` is in the `errors` object, trigger the `onerror`
        // callback.
        if (errors[url]) {
            img.onerror.call(img);
            return;
        }
        // Set the img src to trigger loading
        img.src = url;
        // If the image is already complete (i.e. cached), trigger the
        // `onload` callback.
        if (img.complete) {
            img.onload.call(img);
        }
    }
}
ImagePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ImagePipe, deps: [{ token: ConfigurationService }, { token: i2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
ImagePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ImagePipe, name: "image", pure: false });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ImagePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'image',
                    pure: false
                }]
        }], ctorParameters: function () { return [{ type: ConfigurationService }, { type: i2.DomSanitizer }]; } });

/**
 * Core pipe to convert bytes into largest possible unit.
 * ### Example:
 ```html
    <!-- Formats to 1 KB for users -->
    <span>{{1024 | fileSize}}</span>
 ```
 */
class FileSizePipe {
    constructor() {
        this.units = ['bytes', 'KB', 'MB', 'GB', 'TB'];
    }
    transform(bytes = 0) {
        if (isNaN(parseFloat(String(bytes))) || !isFinite(bytes))
            return '';
        let unit = 0;
        while (bytes >= 1024) {
            bytes /= 1024;
            unit++;
        }
        return Math.round(bytes) + ' ' + this.units[unit];
    }
}
FileSizePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FileSizePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
FileSizePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FileSizePipe, name: "fileSize" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FileSizePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fileSize'
                }]
        }] });

/*
 * This pipe truncates a string.
 * Use it like so {{ String expression | truncate:15 }}
 * This truncates the string to 10 letters and adds '...' to end.
 * ### Example:
 ```html
    <span>{{'this is a very long statement' | truncate:15 }}</span>
 ```
 * Output : this is a very ...
*/
class TruncatePipe {
    transform(value, limit) {
        return value.length < limit
            ? value
            : value.slice(0, limit) + '...';
    }
}
TruncatePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TruncatePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
TruncatePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TruncatePipe, name: "truncate" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TruncatePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'truncate' }]
        }] });

const AField = (options) => {
    return (target, property) => {
        const classConstructor = target.constructor;
        const metadata = Reflect.getOwnMetadata('fields', classConstructor) || {};
        metadata[property] = options;
        Reflect.defineMetadata('fields', metadata, classConstructor);
    };
};

function ATable(metadata) {
    return function (target) {
        Reflect.defineMetadata('aobject', metadata, target);
    };
}
function ATableType(objectType) {
    return function (target) {
        target.type = objectType;
    };
}

class SimpleDate {
    constructor(value) {
        this.value = value;
    }
    setDate(value) {
        this.value = value;
    }
    getSimpleDate() {
        return this.value.toISOString().substr(0, 10);
    }
}

class AObjectMetadata {
    generatedId() {
        let hashKey = Reflect.getOwnMetadata('hashKey', this.constructor);
        if (hashKey)
            return hashKey;
        else {
            const modelKey = `${JSON.stringify(Reflect.getOwnMetadata('aobject', this.constructor))}.${JSON.stringify(this)}`;
            const key = modelKey.split('').reduce((a, b) => { a = ((a << 5) - a) + b.charCodeAt(0); return a & a; }, 0);
            Reflect.defineMetadata('hashKey', key, this.constructor);
            return key;
        }
    }
    getFieldMetadata(filter) {
        const loop = (i, fieldObj = {}) => {
            const fields = Reflect.getMetadata('fields', i.constructor);
            if (!_.isEmpty(_.keys(fields))) {
                return loop(Reflect.getPrototypeOf(i), _.assign({}, fields, fieldObj));
            }
            else {
                return fieldObj;
            }
        };
        return (!_.isNil(filter)) ? _.pickBy(loop(this), filter) : loop(this);
    }
    getFieldMetadataFromExpose(filter) {
        const loop = (i, fieldObj = {}) => {
            const fields = _.mapValues(_.mapKeys(defaultMetadataStorage.getExposedMetadatas(i.constructor), (value) => value.propertyName), (o) => o.options);
            if (!_.isEmpty(_.keys(fields))) {
                return _.assign({}, fields, fieldObj);
            }
        };
        return (!_.isNil(filter)) ? _.pickBy(loop(this), filter) : loop(this);
    }
    set(key, value) {
        _.set(this, `_metadata.${key}`, value);
    }
    get(key) {
        return _.get(this, `_metadata.${key}`);
    }
    getType() {
        return this.constructor;
    }
    getMetadata(field) {
        if (!_.isNil(field))
            return _.get(Reflect.getMetadata('fields', this.constructor), field);
        else
            return Reflect.getMetadata('aobject', this.constructor);
    }
    getMetadataFromExpose(field) {
        if (!_.isNil(field))
            return _.get(_.mapValues(_.mapKeys(defaultMetadataStorage.getExposedMetadatas(this.constructor), 'propertyName'), 'options'), field);
        else
            return _.mapValues(_.mapKeys(defaultMetadataStorage.getExposedMetadatas(this.constructor), 'propertyName'), 'options');
    }
    getTypeMetadata(fieldName) {
        if (this.constructor)
            return defaultMetadataStorage.findTypeMetadata(this.constructor, fieldName);
        else
            return undefined;
    }
    getExposeMetadata(fieldName) {
        if (this.constructor)
            return defaultMetadataStorage.findExposeMetadata(this.constructor, fieldName);
        else
            return undefined;
    }
    getKeys() {
        if (this.hasExpose())
            return _.keys(this.getFieldMetadataFromExpose());
        else
            return _.keys(this.getFieldMetadata());
    }
    getKey(apiName) {
        if (this.hasExpose())
            return _.first(_.keys(this.getFieldMetadataFromExpose(f => _.get(f, 'name') === apiName)));
        else
            return _.first(_.keys(this.getFieldMetadata(f => _.get(f, 'soql') === apiName)));
    }
    /**
     * Method returns the object primitive values removing any salesforce ids and default salesforce values (i.e. created date, last modified date etc)
     */
    strip() {
        return _.omitBy(_.pickBy(this, (a, b) => _.identity(a, b) && !_.startsWith(b, '_') && b !== 'hasErrors'), _.isObject);
    }
    instanceOf(fieldName) {
        // 'PriceList.Account';
        const fieldParts = _.split(fieldName, '.');
        let instance;
        _.forEach(fieldParts, part => {
            let i = _.defaultTo(instance, this);
            const metadata = i.getTypeMetadata(part);
            if (_.get(i, part) instanceof AObject)
                instance = _.get(i, part);
            else if (_.get(metadata, 'typeFunction')) {
                const classType = metadata.typeFunction();
                instance = new classType();
            }
            else if (_.isArray(_.get(i, part)))
                instance = _.first(_.get(i, part));
        });
        return _.defaultTo(instance, this);
    }
    // This method will return true if the model has Expose decorator and returns false if the model has AField decorator.
    hasExpose() {
        const defaultFields = ['Id', 'CreatedDate', 'LastModifiedDate', 'LastModifiedById', 'CreatedById'];
        const fields = this.getFieldMetadataFromExpose();
        return (_.pullAll(_.keys(fields), defaultFields).length > 0);
    }
    getApiName(field, platform = 'Salesforce') {
        const memod = (f, p) => {
            if (!_.isNil(f)) {
                const fieldParts = _.split(f, '.');
                const fieldReference = fieldParts.pop();
                let instance, fields, subField;
                let prefix = '';
                _.forEach(fieldParts, part => {
                    prefix += (_.isNil(instance)
                        ? this.getApiName(part, p)
                        : instance.getApiName(part, p)) + '.';
                    instance = (_.isNil(instance)) ? this.instanceOf(part) : instance.instanceOf(part);
                });
                const isExpose = !_.isNil(instance) ? instance.hasExpose() : this.hasExpose();
                if (isExpose) {
                    fields = !_.isNil(instance) ? instance.getFieldMetadataFromExpose() : this.getFieldMetadataFromExpose();
                    subField = _.defaultTo(_.get(fields, `${fieldReference}.${'name'}`), field);
                }
                else {
                    fields = !_.isNil(instance) ? instance.getFieldMetadata() : this.getFieldMetadata();
                    subField = _.defaultTo(_.get(fields, `${fieldReference}.${(p === 'Salesforce') ? 'soql' : 'aql'}`), field);
                }
                return prefix + subField;
            }
            else {
                return _.get(Reflect.getMetadata('aobject', this.constructor), (p === 'AIC') ? 'aqlName' : 'sobjectName');
            }
        };
        return memod(field, platform);
    }
    getReferenceFields(type) {
        if (!_.isNil(type)) {
            return Object.keys(this.getFieldMetadata()).filter(key => this.getReferenceType(key) === type);
        }
        else {
            return Object.keys(this.getFieldMetadata()).filter(key => this.getReferenceType(key) === 'Child' || this.getReferenceType(key) === 'Lookup');
        }
    }
    getReferenceFieldsFromExpose(type) {
        if (!_.isNil(type)) {
            return Object.keys(this.getFieldMetadataFromExpose()).filter(key => this.getReferenceType(key) === type);
        }
        else {
            return Object.keys(this.getFieldMetadataFromExpose()).filter(key => this.getReferenceType(key) === 'Child' || this.getReferenceType(key) === 'Lookup');
        }
    }
    getReferenceType(fieldName) {
        const metadata = this.getTypeMetadata(fieldName);
        if (_.get(metadata, 'reflectedType') && new metadata.reflectedType() instanceof AObject === false && Array.isArray(metadata.reflectedType()))
            return 'Child';
        else if (Array.isArray(_.get(this, fieldName)) && _.get(this, `${fieldName}[0]`) instanceof AObject)
            return 'Child';
        else if (_.get(metadata, 'typeFunction')) {
            return 'Lookup';
        }
        else if (_.get(this, fieldName) instanceof AObject) {
            return 'Lookup';
        }
        else
            return undefined;
    }
    toApiJson(platform = 'Salesforce') {
        const fieldMap = this.getFieldMetadata((metadata) => !_.isNil(metadata.soql));
        const fieldMapKeys = Object.keys(fieldMap);
        const untyped = {
            attributes: {
                type: this.getApiName(null, platform)
            }
        };
        const suffix = platform === 'Salesforce' ? 'soql' : 'aql';
        const referenceKeys = this.getReferenceFields();
        const currencyKeys = ['DefaultCurrencyIsoCode', 'CurrencyIsoCode', 'CountryCode', 'StateCode'];
        _.forEach(fieldMapKeys, fieldKey => {
            if (!_.isPlainObject(_.get(this, fieldKey)) && !_.includes(referenceKeys, fieldKey) && !_.includes(currencyKeys, fieldKey)) {
                if (_.isArray(_.get(this, fieldKey)))
                    _.set(untyped, _.get(fieldMap, `${fieldKey}.${suffix}`), _.join(_.get(this, fieldKey), ';'));
                else
                    _.set(untyped, _.get(fieldMap, `${fieldKey}.${suffix}`), _.get(this, fieldKey));
            }
        });
        return untyped;
    }
    toApiJsonFromExpose(platform = 'Salesforce') {
        const fieldMap = this.getFieldMetadataFromExpose((metadata) => !_.isNil(metadata.name));
        const fieldMapKeys = Object.keys(fieldMap);
        const untyped = {
            attributes: {
                type: this.getApiName(null, platform)
            }
        };
        const suffix = 'name';
        const referenceKeys = this.getReferenceFieldsFromExpose();
        const currencyKeys = ['DefaultCurrencyIsoCode', 'CurrencyIsoCode', 'CountryCode', 'StateCode'];
        _.forEach(fieldMapKeys, fieldKey => {
            if (!_.isPlainObject(_.get(this, fieldKey)) && !_.includes(referenceKeys, fieldKey) && !_.includes(currencyKeys, fieldKey)) {
                _.set(untyped, _.get(fieldMap, `${fieldKey}.${suffix}`), _.get(this, `${fieldKey}`));
            }
        });
        return untyped;
    }
    get errors() {
        this.validate();
        return _.compact(_.values(this.get('error')));
    }
    set errors(e) { }
    get hasErrors() {
        return _.get(this.errors, 'length', 0) > 0;
    }
    set hasErrors(e) { }
    setError(key, param, type = 'error', children, reference) {
        this.set(`error['${key}']`, new AObjectError(key, param, type, children, reference));
    }
    clearError(key) {
        if (!_.isNil(key))
            this.set(`error['${key}']`, null);
        else
            this.set(`error`, null);
    }
}
__decorate([
    memoize(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function]),
    __metadata("design:returntype", Object)
], AObjectMetadata.prototype, "getFieldMetadata", null);
__decorate([
    memoize(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function]),
    __metadata("design:returntype", Object)
], AObjectMetadata.prototype, "getFieldMetadataFromExpose", null);
__decorate([
    memoize(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], AObjectMetadata.prototype, "getApiName", null);
class AObject extends AObjectMetadata {
    constructor() {
        super(...arguments);
        this.Id = null;
        this.CreatedDate = null;
        this.LastModifiedDate = null;
        this.LastModifiedById = null;
        this.CreatedById = null;
    }
    validate() { }
}
__decorate([
    AField({
        aql: 'Id',
        soql: 'Id'
    }),
    Expose({ name: 'Id' }),
    __metadata("design:type", String)
], AObject.prototype, "Id", void 0);
__decorate([
    AField({
        aql: 'CreatedOn',
        soql: 'CreatedDate'
    }),
    Expose({ name: 'CreatedDate' }),
    __metadata("design:type", Date)
], AObject.prototype, "CreatedDate", void 0);
__decorate([
    AField({
        aql: 'ModifiedOn',
        soql: 'LastModifiedDate'
    }),
    Expose({ name: 'LastModifiedDate' }),
    __metadata("design:type", Date)
], AObject.prototype, "LastModifiedDate", void 0);
__decorate([
    AField({
        aql: 'ModifiedById',
        soql: 'LastModifiedById'
    }),
    Expose({ name: 'LastModifiedById' }),
    __metadata("design:type", String)
], AObject.prototype, "LastModifiedById", void 0);
__decorate([
    AField({
        aql: 'CreatedById',
        soql: 'CreatedById'
    }),
    Expose({ name: 'CreatedById' }),
    __metadata("design:type", String)
], AObject.prototype, "CreatedById", void 0);
class AObjectError extends Error {
    constructor(m, parameter, type = 'error', children, reference) {
        super(m);
        this.parameter = parameter;
        this.type = type;
        this.children = children;
        this.reference = reference;
        this.children = _.compact(this.children);
        if (!_.isNil(parameter) && !_.isPlainObject(parameter)) {
            throw new Error('Error parameter must be of type plain object or null');
        }
    }
}
class ACondition {
    constructor(type, field, filterOperator, val) {
        this.type = type;
        this.field = field;
        this.filterOperator = filterOperator;
        this.val = val;
        this.setValue(val);
        this.apiName = new this.type().getApiName();
    }
    setValue(val) {
        if (val instanceof Array) {
            this.value = _.join(val, ',');
        }
        else if (val instanceof SimpleDate) {
            this.value = val.getSimpleDate();
        }
        else if (val instanceof Date) {
            this.value = val.toISOString();
        }
        else {
            this.value = val;
        }
    }
}
class AFilter {
    constructor(type, conditions, filters, expressionOperator = 'AND') {
        this.type = type;
        this.conditions = conditions;
        this.filters = filters;
        this.expressionOperator = expressionOperator;
        this.apiName = new this.type().getApiName();
    }
}
class AJoin {
    constructor(type, fromAttribute, toAttribute, conditions, expressionOperator = 'AND', filters) {
        this.type = type;
        this.fromAttribute = fromAttribute;
        this.toAttribute = toAttribute;
        this.conditions = conditions;
        this.expressionOperator = expressionOperator;
        this.filters = filters;
        this.apiName = new this.type().getApiName();
    }
}
class ASort {
    constructor(type, field, direction = 'ASC') {
        this.type = type;
        this.field = field;
        this.direction = direction;
        this.apiName = new this.type().getApiName();
    }
}
class APageInfo {
    constructor(pageLimit = 10000, pageNumber) {
        this.pageLimit = pageLimit;
        this.pageNumber = pageNumber;
    }
}
class AChildFilter {
    constructor(field, filterList, sortField, order = 'ASC', page) {
        this.field = field;
        this.filterList = filterList;
        this.sortField = sortField;
        this.order = order;
        this.page = page;
    }
}
var Operator;
(function (Operator) {
    Operator["EQUAL"] = "Equal";
    Operator["NOT_EQUAL"] = "NotEqual";
    Operator["GREATER_THAN"] = "GreaterThan";
    Operator["LESS_THAN"] = "LessThan";
    Operator["GREATER_EQUAL"] = "GreaterEqual";
    Operator["LESS_EQUAL"] = "LessEqual";
    Operator["LIKE"] = "Like";
    Operator["NOT_LIKE"] = "NotLike";
    Operator["CONTAINS"] = "Contains";
    Operator["DOES_NOT_CONTAIN"] = "DoesNotContain";
    Operator["BEGINS_WITH"] = "BeginsWith";
    Operator["DOES_NOT_BEGIN_WITH"] = "DoesNotBeginWith";
    Operator["ENDS_WITH"] = "EndsWith";
    Operator["DOES_NOT_END_WITH"] = "DoesNotEndWith";
    Operator["IN"] = "In";
    Operator["NOT_IN"] = "NotIn";
    Operator["NULL"] = "Null";
    Operator["NOT_NULL"] = "NotNull";
    Operator["ON"] = "On";
    Operator["LAST_X_DAYS"] = "LastXDays";
    Operator["NEXT_X_DAYS"] = "NextXDays";
    Operator["TODAY"] = "Today";
    Operator["INCLUDES"] = "Includes";
})(Operator || (Operator = {}));

class SalesforceUtils {
    static sfidChecksum(id) {
        const bin1 = ((~id.charCodeAt(0) >> 5 & 1) << 0) |
            ((~id.charCodeAt(1) >> 5 & 1) << 1) |
            ((~id.charCodeAt(2) >> 5 & 1) << 2) |
            ((~id.charCodeAt(3) >> 5 & 1) << 3) |
            ((~id.charCodeAt(4) >> 5 & 1) << 4);
        const bin2 = ((~id.charCodeAt(5) >> 5 & 1) << 0) |
            ((~id.charCodeAt(6) >> 5 & 1) << 1) |
            ((~id.charCodeAt(7) >> 5 & 1) << 2) |
            ((~id.charCodeAt(8) >> 5 & 1) << 3) |
            ((~id.charCodeAt(9) >> 5 & 1) << 4);
        const bin3 = ((~id.charCodeAt(10) >> 5 & 1) << 0) |
            ((~id.charCodeAt(11) >> 5 & 1) << 1) |
            ((~id.charCodeAt(12) >> 5 & 1) << 2) |
            ((~id.charCodeAt(13) >> 5 & 1) << 3) |
            ((~id.charCodeAt(14) >> 5 & 1) << 4);
        return SalesforceUtils.checksumAlphabet[bin1] + SalesforceUtils.checksumAlphabet[bin2] + SalesforceUtils.checksumAlphabet[bin3];
    }
    static sfidRegexp(completeMatch) {
        return completeMatch ?
            /^[A-Za-z0-9]{15}(?:[A-Za-z0-9]{3})?$/ :
            /[A-Za-z0-9]{15}(?:[A-Za-z0-9]{3})?/g;
    }
    static sfidLongId(id) {
        // Ensure string and check basic format
        id = '' + id;
        if (!SalesforceUtils.idRegexp.test(id)) {
            return '';
        }
        // For 15-chars (short) id, we append the checksum
        if (id.length === 15) {
            return id + SalesforceUtils.sfidChecksum(id);
        }
        // For 18-chars (long) id, we verify the checksum
        if (id.substring(15, 18) === SalesforceUtils.sfidChecksum(id)) {
            return id;
        }
        // From here on we assume the checksum is valid for the 18-chars id, so we correct the case of the first part of the id. Fx. this fixes ids that were fully upper-cased.
        // Parse checksum
        const checksum = id.substring(15, 18).toUpperCase();
        const bins = [
            SalesforceUtils.checksumAlphabet.indexOf(checksum[0]),
            SalesforceUtils.checksumAlphabet.indexOf(checksum[1]),
            SalesforceUtils.checksumAlphabet.indexOf(checksum[2])
        ];
        // Invalid checksum
        if (bins[0] === -1 || bins[1] === -1 || bins[2] === -1) {
            return '';
        }
        // Make each character of 15-chars (short) id upper case according to checksum
        id = id.substring(0, 15).toLowerCase();
        for (let i = 0; i < 3; i++) {
            let bin = bins[i];
            for (let position = i * 5; bin; position++, bin >>= 1) {
                if (bin & 1) {
                    // Invalid character (not A-Z)
                    if (id.charCodeAt(position) < 97) {
                        return '';
                    }
                    // Make position upper-case
                    id = id.substring(0, position) + id[position].toUpperCase() + id.substring(position + 1);
                }
            }
        }
        // Return id with correct upper/lower case
        return id + checksum;
    }
    static sfidShortId(id) {
        return SalesforceUtils.sfidLongId(id).substring(0, 15);
    }
    static isEqual(a, b) {
        return SalesforceUtils.sfidShortId(a) === SalesforceUtils.sfidShortId(b);
    }
    static isValid(id) {
        return !!SalesforceUtils.sfidLongId(id);
    }
    static getDefaultValue(metadata) {
        return _.get(metadata, 'defaultValue');
    }
    static hashCode(data) {
        let hash = 0;
        if (data.length === 0) {
            return hash;
        }
        for (let i = 0; i < data.length; i++) {
            const char = data.charCodeAt(i);
            hash = ((hash << 5) - hash) + char;
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash;
    }
}
SalesforceUtils.checksumAlphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ012345';
SalesforceUtils.idRegexp = SalesforceUtils.sfidRegexp(true);
__decorate([
    MemoizeAll(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SalesforceUtils, "hashCode", null);

class TreeUtils {
    static arrayToTree(data, options) {
        options = Object.assign({
            parentProperty: 'parent_id',
            childrenProperty: 'children',
            customID: 'id',
            rootID: '0'
        }, options);
        if (!Array.isArray(data)) {
            throw new TypeError('Expected an array but got an invalid argument');
        }
        const grouped = TreeUtils.groupByParents(data, options);
        return TreeUtils.createTree(grouped, grouped[options.rootID], options.customID, options.childrenProperty);
    }
    static createTree(array, rootNodes, customID, childrenProperty) {
        const tree = [];
        for (const rootNode in rootNodes) {
            const node = rootNodes[rootNode];
            const childNode = array[_.get(node, customID)];
            if (!node && !rootNodes.hasOwnProperty(rootNode)) {
                continue;
            }
            if (childNode) {
                _.set(node, childrenProperty, TreeUtils.createTree(array, childNode, customID, childrenProperty));
            }
            tree.push(node);
        }
        return tree;
    }
    static groupByParents(array, options) {
        const arrayByID = _.keyBy(array, options.customID);
        return array.reduce(function (prev, item) {
            let parentID = _.get(item, options.parentProperty);
            if (!parentID || !arrayByID.hasOwnProperty(parentID)) {
                parentID = options.rootID;
            }
            if (parentID && prev.hasOwnProperty(parentID)) {
                prev[parentID].push(item);
                return prev;
            }
            prev[parentID] = [item];
            return prev;
        }, {});
    }
}

class CacheService {
    constructor(ngZone, configurationService) {
        this.ngZone = ngZone;
        this.configurationService = configurationService;
        this.cache = [];
        this.bufferCache = {};
        this.CACHE_VERSION = 12;
        this.DB_STORE = 'cache';
        this.DB_NAME = 'ApttusDC';
        this.encryptionKey = CryptoJS.enc.Base64.parse(PlatformConstants.SV);
        this._cache = {};
        this.keyStore = new Array();
    }
    /**
     * Method clears data from cache and database. When removeReference is set to true, it will also remove the cache reference from memory
     * and also break any existing observable streams to the interface.
     * @param keyList The list of keys to clear
     * @param removeReference Set to true to remove cache pointers from memory
     */
    clearCache(keyList, removeReference = false) {
        if (removeReference)
            this.cache = _.filter(this.cache, c => !_.includes(keyList, _.get(c, 'id')));
        _.forEach(_.filter(this.cache, c => _.includes(keyList, _.get(c, 'id'))), cacheRecord => {
            cacheRecord.subject.next(undefined);
            cacheRecord.data = null;
        });
        return this.clearDatabase(keyList);
    }
    /**
     * Method will clear records from the indexeddb. If no keylist is specified it will clear the whole database.
     * @param keyList The keys to clear
     */
    clearDatabase(keyList) {
        if (this.db) {
            if (!_.isEmpty(keyList)) {
                return Promise.all(_.map(keyList, key => this.db.delete(this.DB_STORE, key)));
            }
            else {
                return this.db.clear(this.DB_STORE);
            }
        }
        else {
            return Promise.resolve(true);
        }
    }
    /*
     * Method clears the whole cache
     */
    clear() {
        this.cache = [];
        return from(this.clearDatabase());
    }
    _set(key, data, local = false) {
        this._cache[key] = data;
        if (local) {
            if (typeof data === 'object')
                localStorage.setItem(key, data);
            else
                localStorage.setItem(key, data);
        }
    }
    _get(key) {
        if (this._cache[key])
            return this._cache[key];
        else if (localStorage.getItem(key))
            try {
                return JSON.parse(localStorage.getItem(key));
            }
            catch (e) {
                return localStorage.getItem(key);
            }
        else
            return null;
    }
    /**
     * Wrapper method to cacheService.get. Provides predefined default values in object format
     * @param request CacheRequest interface
     */
    fromCache(type, key, executable, options) {
        const _o = _.assign({
            skipCache: false,
            parse: true,
            strategy: 'freshness',
            useIndexedDB: false
        }, options);
        return this.get(type, key, executable, _o.useIndexedDB, _o.skipCache, _o.parse, _o.strategy);
    }
    get(type, key, executable, useIndexedDB = false, skipCache = false, parse = true, strategy = 'freshness') {
        const hashKey = SalesforceUtils.hashCode(key);
        let cacheRecord = _.find(this.cache, (c) => c.id === hashKey && c.type === type);
        if (_.isNil(cacheRecord)) {
            const subject = new BehaviorSubject(undefined);
            cacheRecord = {
                id: hashKey,
                type: type,
                executable: executable,
                subject: subject,
                output: subject.pipe(filter(r => !_.isUndefined(r)), distinctUntilChanged((a, b) => this.isEqual(a, b)), map(r => _.cloneDeep(r)), tap(data => {
                    if (cacheRecord.skipCache) {
                        _.remove(this.cache, c => c.id === cacheRecord.id);
                    }
                    else {
                        cacheRecord.data = data;
                    }
                })),
                parse: parse,
                skipCache: skipCache,
                strategy: strategy
            };
            this.cache.push(cacheRecord);
            this.publish(cacheRecord, useIndexedDB);
        }
        return cacheRecord.output;
    }
    buffer(bufferKey, value, executable, dataMap, bufferTimeInMilliseconds, bufferCount, debounceResult = false) {
        let bufferData = _.find(_.get(this.bufferCache, bufferKey), d => _.get(d, 'state.value') === 'open');
        bufferTimeInMilliseconds = _.defaultTo(bufferTimeInMilliseconds, this.configurationService.get('disableBuffer', false) === true ? 0 : this.configurationService.get('bufferTime', 50));
        bufferCount = _.defaultTo(bufferCount, this.configurationService.get('disableBuffer', false) === true ? 1 : this.configurationService.get('maxBufferSize', 10));
        if (_.isNil(bufferData)) {
            const state = new BehaviorSubject('open');
            let acc = new BehaviorSubject(value).pipe(bufferTime(bufferTimeInMilliseconds, undefined, bufferCount));
            if (debounceResult) {
                acc = new BehaviorSubject(value).pipe(tap(d => _.set(bufferData, 'data', _.concat(_.get(bufferData, 'data', []), d))), debounceTime(this.configurationService.get('debounceTime', 1000)), map(() => _.get(bufferData, 'data')));
            }
            bufferData = {
                state: state,
                accumulator: acc
                    .pipe(filter(x => !_.isEmpty(x)), takeUntil(state.pipe(filter(s => s === 'closed'))), mergeMap(data => {
                    state.next('running');
                    return bufferData.executable(_.flatten(data));
                }), tap(d => {
                    state.next('closed');
                    _.remove(_.get(this.bufferCache, bufferKey), x => !_.includes(['open', 'running'], _.get(x, 'state.value')));
                }), share()),
                executable: executable
            };
            _.set(this.bufferCache, bufferKey, _.concat(_.get(this.bufferCache, bufferKey, []), bufferData));
        }
        else
            bufferData.accumulator.next(value);
        return bufferData.accumulator.pipe(map(data => {
            return (!_.isNil(dataMap)) ? dataMap(data) : data;
        }));
    }
    onDML(recordList) {
        let idList = [];
        _.forEach(recordList, r => {
            _.forEach(_.values(r), y => {
                if (_.isString(y) && SalesforceUtils.isValid(y))
                    idList.push(y);
            });
        });
        idList = _.compact(idList);
        const f = new Fuse(this.cache, {
            id: 'id',
            shouldSort: true,
            tokenize: true,
            findAllMatches: true,
            includeScore: true,
            threshold: 0,
            location: 0,
            distance: 100,
            maxPatternLength: _.get(idList, 'length') * 19,
            minMatchCharLength: 1,
            keys: [
                'data.Id'
            ]
        });
        // Get a list of cache keys
        const cacheKeys = _.map(f.search(_.join(idList, ' ')), fuz => Number(_.get(fuz, 'item')));
        // Only update those that have a cache strategy of freshness
        const toUpdate = _.filter(this.cache, c => _.includes(cacheKeys, c.id) && c.strategy === 'freshness');
        _.forEach(toUpdate, r => this.update(_.get(r, 'id')));
    }
    /**
     * Wrappper to update
     */
    refresh(key) {
        this.update(key);
    }
    /**
     * Method replaces the executable on a cache key
     * @param key a reference to a cache key
     * @param executable the new executable to use for that cache key
     */
    setExecutable(key, executable) {
        const cacheRecords = this.getCacheRecords(key);
        this.clearDatabase(_.map(cacheRecords, 'id')).then(() => {
            _.forEach(cacheRecords, rec => _.set(rec, 'executable', executable));
        });
    }
    /**
     * @description
     * Method is similar to refresh, but more generic.
     * looks for all cache items related to the input and attempts to update the state.
     * Not perfect, may not update all data everywhere in the app (i.e. child data). Useful for top level data
     * If no data is passed into the state, it will pull the latest from the server.
     *
     * @param key a string, number or class type to update.
     * @param newState optional state data. If null, will update cache with server data. When not null, will update cache with client data only.
     * @param executable optional executable function. Will replace existing executable funciton in the cache.
     * @param relatedRecords when set to true, will update state for related records (default true)
     */
    update(key, newState, relatedRecords = true) {
        let cacheRecords = this.getCacheRecords(key, relatedRecords, 'freshness');
        const keys = this.getKeysForRecords(cacheRecords);
        const fullKeyList = _.concat(keys, _.map(cacheRecords, 'id'));
        this.clearDatabase(fullKeyList).then(() => {
            _.forEach(_.compact(cacheRecords), c => {
                let oldData = _.cloneDeep(_.get(c, 'data'));
                // Immediatley publish the new state to cache records if one is provided
                if (!_.isNil(newState)) {
                    const handleRecord = (record) => {
                        _.set(record, 'LastModifiedDate', new Date());
                        // Iterate through the cache record data
                        if (_.isArray(oldData)) {
                            let hasId = false;
                            _.forEach(oldData, (od, index) => {
                                if (_.get(od, 'Id') === _.get(record, 'Id')) {
                                    oldData.splice(index, 1, record);
                                    hasId = true;
                                }
                            });
                            if (!hasId)
                                oldData.push(record);
                        }
                        else if (_.isObject(oldData) && _.get(oldData, 'Id') === _.get(record, 'Id')) {
                            _.set(c, 'data', record);
                        }
                    };
                    if (_.isArray(newState)) {
                        _.forEach(newState, r => handleRecord(r));
                    }
                    else if (_.isObject(newState))
                        handleRecord(newState);
                    this.push(c.id, oldData);
                }
                else {
                    c.dirty = true;
                    this.publish(c, true, false);
                }
            });
        });
    }
    /**
     * Method immediatley pushes a new value to existing cache subscribers
     * @param hashKey The cache key identifier to update
     * @param data The data to push to the cache subject
     */
    push(hashKey, data) {
        const callback = () => {
            const cacheRecord = _.find(this.cache, c => c.id === hashKey);
            if (!_.isNil(cacheRecord)) {
                cacheRecord.subject.next(undefined);
                if (!_.isEmpty(cacheRecord.subject.observers))
                    this.ngZone.run(() => cacheRecord.subject.next(data));
                else
                    this.cache = _.filter(this.cache, c => c.id !== cacheRecord.id);
            }
        };
        if (this.db)
            this.db.delete(this.DB_STORE, hashKey).then(() => callback(), () => callback());
        else
            callback();
    }
    getCacheRecords(key, related = false, strategy) {
        // Garbage collection
        const empty = _.filter(this.cache, c => _.get(c, 'subject.observers.length') === 0);
        this.clearDatabase(_.map(empty, 'id')).then(() => _.remove(this.cache, c => _.includes(_.map(empty, 'id'), _.get(c, 'id'))));
        let cacheRecords = [];
        if (_.isString(key)) {
            const hashKey = SalesforceUtils.hashCode(key);
            cacheRecords.push(_.find(this.cache, c => c.id === hashKey));
        }
        else if (_.isNumber(key)) {
            cacheRecords.push(_.find(this.cache, c => c.id === key));
        }
        else {
            cacheRecords = _.filter(this.cache, c => c.type === key);
        }
        let relatedRecords = [];
        // Get child keys from data
        if (related === true) {
            relatedRecords = _.filter(this.cache, c => _.includes(this.getKeysForRecords(cacheRecords), c.id));
            if (!_.isNil(strategy))
                relatedRecords = _.filter(relatedRecords, r => r.strategy === strategy);
            cacheRecords = _.concat(cacheRecords, relatedRecords);
        }
        return _.uniqBy(cacheRecords, 'id');
    }
    getKeysForRecords(cacheRecordList) {
        const keyList = new Set();
        const getKeys = (record) => {
            keyList.add(_.get(record, '_metadata.cacheKey'));
            _.forEach(_.values(_.pickBy(record, _.isArray)), recordList => {
                _.forEach(recordList, cr => getKeys(cr));
            });
            _.forEach(_.values(_.pickBy(record, r => _.isPlainObject(r) && r instanceof AObject)), cr => {
                getKeys(cr);
            });
        };
        _.forEach(cacheRecordList, c => {
            if (_.isArray(_.get(c, 'data')))
                _.forEach(_.get(c, 'data'), data => getKeys(data));
            else if (_.isPlainObject(_.get(c, 'data')) && _.get(c, 'data') instanceof AObject) {
                getKeys(_.get(c, 'data'));
            }
        });
        return _.compact(Array.from(keyList));
    }
    guid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4();
    }
    encrypt(data) {
        if (!_.isNil(data)) {
            return of(CryptoJS.AES.encrypt(JSON.stringify(data), this.encryptionKey, {
                iv: CryptoJS.enc.Base64.parse(PlatformConstants.IV),
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }).toString());
        }
        else {
            return of(null);
        }
    }
    decrypt(encryptedString) {
        const d = new Date().getTime();
        if (!_.isNil(encryptedString)) {
            return of(CryptoJS.AES.decrypt(encryptedString, this.encryptionKey, {
                iv: CryptoJS.enc.Base64.parse(PlatformConstants.IV),
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }).toString(CryptoJS.enc.Utf8)).pipe(map(strData => {
                return JSON.parse(strData);
            }));
        }
        else {
            return of(null);
        }
    }
    isEqual(oldData, newData) {
        const undefinedAsNull = (k, v) => (v === undefined) ? null : v;
        const handleObject = (obj1, obj2) => {
            const arrayKeys = _.keys(_.pickBy(obj2, _.isArray));
            const objectKeys = _.keys(_.pickBy(obj2, o => o instanceof AObject));
            const arraysEqual = _.every(arrayKeys, key => handleArrays(_.get(obj1, key), _.get(obj2, key)));
            const objectsEqual = _.every(objectKeys, key => handleObject(_.get(obj1, key), _.get(obj2, key)));
            const dataEqual = (_.has(obj2, 'Id'))
                // tslint:disable-next-line:triple-equals
                ? (_.get(obj1, 'Id') == _.get(obj2, 'Id') && _.get(obj1, 'LastModifiedDate') == _.get(obj2, 'LastModifiedDate'))
                : _.isMatch(obj1, obj2);
            return (dataEqual && arraysEqual && objectsEqual);
        };
        const handleArrays = (arr1, arr2) => {
            return _.get(arr1, 'length') === _.get(arr2, 'length') && _.every(arr2, i => handleObject(_.find(arr1, elem => _.get(elem, 'Id') === _.get(i, 'Id')), i));
        };
        let lite = false;
        if (_.isNil(oldData) && !_.isNil(newData))
            return false;
        else {
            try {
                lite = JSON.stringify(oldData, undefinedAsNull) === JSON.stringify(newData, undefinedAsNull);
            }
            catch (e) {
                return _.isEqualWith(oldData, newData, (a, b) => (_.isArray(a) || _.isArray(b)) ? handleArrays(a, b) : handleObject(a, b));
            }
            if (!lite)
                return _.isEqualWith(oldData, newData, (a, b) => (_.isArray(a) || _.isArray(b)) ? handleArrays(a, b) : handleObject(a, b));
            else
                return lite;
        }
    }
    publish(cacheKey, useIndexedDB = true, pushFromIndex = true) {
        cacheKey.executable().pipe(take(1)).subscribe(res => {
            this.ngZone.run(() => cacheKey.subject.next(res));
        }, err => this.ngZone.run(() => cacheKey.subject.error(err)));
    }
}
CacheService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CacheService, deps: [{ token: i0.NgZone }, { token: ConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
CacheService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CacheService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CacheService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i0.NgZone }, { type: ConfigurationService }]; } });

class RavenErrorHandler extends ErrorHandler {
    constructor(configurationService, cacheService) {
        super();
        this.configurationService = configurationService;
        this.cacheService = cacheService;
        this.errorDebounce = false;
        this.debounceTime = 10000;
        if (this.configurationService.get('sentryDsn')) {
            if (this.configurationService.get('enableErrorLogging') || this.configurationService.get('enableErrorReporting')) {
                const raven = _.bind(Raven.config, Raven);
                raven(this.configurationService.get('sentryDsn')).install();
                this.embedStyle();
            }
        }
    }
    handleError(err) {
        if (this.configurationService.get('enableErrorPrinting') !== false)
            super.handleError(err);
        if (!this.errorDebounce && this.configurationService.get('sentryDsn')) {
            this.errorDebounce = true;
            if (this.configurationService.get('enableErrorLogging') !== false) {
                const capture = _.bind(Raven.captureException, Raven);
                capture(err);
            }
            if (this.configurationService.get('enableErrorReporting')) {
                const report = _.bind(Raven.showReportDialog, Raven);
                report({
                    eventId: event,
                    dsn: this.configurationService.get('sentryDsn')
                });
            }
            setTimeout(() => this.errorDebounce = false, this.debounceTime);
        }
    }
    embedStyle() {
        const css = '.sentry-error-embed{position: absolute; left: 25%; top: 15%;}', head = document.head || document.getElementsByTagName('head')[0], style = document.createElement('style');
        style.type = 'text/css';
        if (style['styleSheet']) {
            style['styleSheet'].cssText = css;
        }
        else {
            style.appendChild(document.createTextNode(css));
        }
        head.appendChild(style);
    }
}
RavenErrorHandler.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RavenErrorHandler, deps: [{ token: ConfigurationService }, { token: CacheService }], target: i0.ɵɵFactoryTarget.Injectable });
RavenErrorHandler.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RavenErrorHandler, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RavenErrorHandler, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: ConfigurationService }, { type: CacheService }]; } });

let _windowConfig$1 = window.sv || {};
class JSForceService {
    static fixIdentity(jsforce, SF_ENDPOINT) {
        jsforce.Connection.prototype.identity = function (options, callback) {
            if (typeof options === 'function') {
                callback = options;
                options = {};
            }
            options = options || {};
            let self = this;
            let idUrl = this.userInfo && this.userInfo.url;
            return Promise.resolve(idUrl ?
                { identity: idUrl } :
                this.request({ method: 'GET', url: this._baseUrl(), headers: options.headers })).then(function (res) {
                let url = res.identity;
                url = url.substring(url.indexOf('.com') + 4);
                url = SF_ENDPOINT + url + '?format=json&oauth_token=' + encodeURIComponent(self.accessToken);
                let transport = undefined;
                return self.request({ method: 'GET', url: url }, { transport: transport });
            }).then(function (res) {
                self.userInfo = {
                    id: res.user_id,
                    organizationId: res.organization_id,
                    url: res.id
                };
                return res;
            }).then(callback);
        };
    }
    static fixSoapLogin(jsforce, organizationId = null, baseUrl) {
        function esc(str) {
            return str && String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;')
                .replace(/>/g, '&gt;').replace(/'/g, '&quot;');
        }
        jsforce.Connection.prototype.loginBySoap = function (username, password, callback) {
            let self = this;
            let logger = this._logger;
            let body = [
                '<se:Envelope xmlns:se="http://schemas.xmlsoap.org/soap/envelope/" xmlns:ns1="urn:partner.soap.sforce.com">',
                '<se:Header>',
                ((organizationId) ? '<ns1:LoginScopeHeader><ns1:organizationId>' + organizationId + '</ns1:organizationId></ns1:LoginScopeHeader>' : ''),
                '</se:Header>',
                '<se:Body>',
                '<ns1:login xmlns="urn:partner.soap.sforce.com">',
                '<ns1:username>' + esc(username) + '</ns1:username>',
                '<ns1:password>' + esc(password) + '</ns1:password>',
                '</ns1:login>',
                '</se:Body>',
                '</se:Envelope>'
            ].join('');
            const resource = _.get(_windowConfig$1, 'resource', '');
            const prefix = resource.substring(0, resource.indexOf('/resource'));
            let soapLoginEndpoint = [baseUrl + '/services/Soap/u', this.version].join('/');
            return this._transport.httpRequest({
                method: 'POST',
                url: soapLoginEndpoint,
                body: body,
                headers: {
                    'Content-Type': 'text/xml',
                    'SOAPAction': '""'
                }
            }).then(function (response) {
                let m;
                if (response.statusCode >= 400) {
                    m = response.body.match(/<faultstring>([^<]+)<\/faultstring>/);
                    let faultstring = m && m[1];
                    throw new Error(faultstring || response.body);
                }
                logger.debug('SOAP response = ' + response.body);
                m = response.body.match(/<serverUrl>([^<]+)<\/serverUrl>/);
                let serverUrl = m && m[1];
                m = response.body.match(/<sessionId>([^<]+)<\/sessionId>/);
                let sessionId = m && m[1];
                m = response.body.match(/<userId>([^<]+)<\/userId>/);
                let userId = m && m[1];
                m = response.body.match(/<organizationId>([^<]+)<\/organizationId>/);
                let orgId = m && m[1];
                let idUrl = soapLoginEndpoint.split('/').slice(0, 3).join('/');
                idUrl += '/id/' + orgId + '/' + userId;
                let userInfo = {
                    id: userId,
                    organizationId: orgId,
                    url: idUrl
                };
                self.initialize({
                    serverUrl: serverUrl.split('/').slice(0, 3).join('/'),
                    sessionId: sessionId,
                    userInfo: userInfo
                });
                logger.debug('<login> completed. user id = ' + userId + ', org id = ' + orgId);
                return userInfo;
            }).thenCall(callback);
        };
    }
    static fixBulk(bulk, jsforce) {
        bulk._request = function (request, callback) {
            let conn = this._conn;
            request = _.clone(request);
            let baseUrl = ['services/async', conn.version].join('/');
            request.url = baseUrl + request.path;
            let options = { responseType: request.responseType };
            delete request.path;
            delete request.responseType;
            return new jsforce.BulkApi(this._conn, options).request(request).thenCall(callback);
        };
    }
    static fixProxy(transport, baseUrl) {
        transport.httpRequest = function (params, callback) {
            let url = params.url;
            if (url.indexOf('/') === 0) {
                url = baseUrl + url;
            }
            let data;
            if (url.indexOf('?') >= 0) {
                params.method = 'POST';
                data = url.substring(url.indexOf('?'));
                url = url.substring(0, url.indexOf('?'));
            }
            let proxyParams = {
                method: params.method,
                url: this._proxyUrl + '?' + Date.now() + '.' + ('' + Math.random()).substring(2),
                body: {},
                headers: {
                    'salesforceproxy-endpoint': url
                }
            };
            if (params.body || params.body === '') {
                proxyParams.body = params.body;
            }
            else if (data) {
                proxyParams.headers['content-type'] = 'application/json';
                proxyParams.body = JSON.stringify({ data: data });
            }
            if (params.headers) {
                for (let name in params.headers) {
                    proxyParams.headers[name] = params.headers[name];
                }
            }
            return transport.__proto__.__proto__.httpRequest.call(this, proxyParams, callback);
        };
    }
    static addSoapCallout(jsforce, production = false) {
        jsforce.Connection.prototype.requestSoap = function (_url, body, method, options, callback) {
            const request = {
                method: 'POST',
                url: _url,
                body: body,
                headers: { 'content-type': 'text/xml', 'SOAPAction': 'urn:' + method, 'Accept': 'text/xml' }
            };
            this._normalizeUrl = function (url) {
                if ((url[0] === '/' && url !== _url) || production) {
                    if (url.indexOf('/services/') === 0) {
                        return this.instanceUrl + url;
                    }
                    else if (url.indexOf('http') < 0) {
                        return this._baseUrl() + url;
                    }
                    else
                        return url;
                }
                else {
                    return url;
                }
            };
            return this.request(request, options, callback);
        };
    }
    static fixLogout(jsforce) {
        jsforce.OAuth2.prototype.revokeToken = function (accessToken, callback) {
            let req;
            if (this._transport.constructor.JsonpTransport.supported) {
                var jsonpTransport = new this._transport.constructor.JsonpTransport('callback');
                req = jsonpTransport.httpRequest({
                    method: 'GET',
                    url: this.revokeServiceUrl + '?' + querystring.stringify({ token: accessToken })
                });
            }
            else {
                req = this._transport.httpRequest({
                    method: 'POST',
                    url: this.revokeServiceUrl,
                    body: querystring.stringify({ token: accessToken }),
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    }
                });
            }
            return req.then(function (response) {
                if (response.statusCode >= 400) {
                    var res = querystring.parse(response.body);
                    if (!res || !res.error) {
                        res = { error: "ERROR_HTTP_" + response.statusCode, error_description: response.body };
                    }
                    var err = new Error(res.error_description + '');
                    err.name = res.error + '';
                    throw err;
                }
            }).thenCall(callback);
        };
    }
    static fixPrompt(jsforce) {
        const popupWin = (url, w, h) => {
            const left = (screen.width / 2) - (w / 2);
            const top = (screen.height / 2) - (h / 2);
            return window.open(url, 'apttus_login', 'location=yes,toolbar=no,status=no,menubar=no,width=' + w + ',height=' + h + ',top=' + top + ',left=' + left);
        };
        jsforce.browser.Client.prototype._prompt = function (options, callback) {
            const self = this;
            const oauth2 = new jsforce.OAuth2(options);
            const rand = Math.random().toString(36).substring(2);
            let state = [this._prefix, 'popup', rand].join('.');
            localStorage.setItem('jsforce_state', state);
            let authzUrl = oauth2.getAuthorizationUrl({
                response_type: 'token',
                scope: options.scope,
                state: state,
                prompt: 'login'
            });
            const size = options.size || {};
            const pw = popupWin(authzUrl, size.width || 912, size.height || 513);
            if (!pw) {
                state = [this._prefix, 'redirect', rand].join('.');
                localStorage.setItem('jsforce_state', state);
                authzUrl = oauth2.getAuthorizationUrl({
                    response_type: 'token',
                    scope: options.scope,
                    state: state,
                    prompt: 'login'
                });
                location.href = authzUrl;
                return;
            }
            self._removeTokens();
            const pid = setInterval(function () {
                try {
                    if (!pw || pw.closed) {
                        clearInterval(pid);
                        const tokens = self._getTokens();
                        if (tokens) {
                            self.connection.initialize(tokens);
                            self.emit('connect', self.connection);
                            callback(null, { status: 'connect' });
                        }
                        else {
                            const err = self._getError();
                            if (err) {
                                callback(new Error(err.error + ': ' + err.error_description));
                            }
                            else {
                                callback(null, { status: 'cancel' });
                            }
                        }
                    }
                }
                catch (e) { }
            }, 1000);
        };
    }
}

class MetadataService {
    constructor(config, injector) {
        this.config = config;
        this.injector = injector;
        this._reflect = Reflect;
        this._fieldCache = {};
        this.types = [];
    }
    getObjectName(aobject) {
        if (aobject) {
            let instance;
            try {
                instance = (aobject instanceof AObject) ? aobject : new aobject();
            }
            catch (e) {
                instance = aobject;
            }
            const metadata = this._reflect.getMetadata('aobject', instance.constructor);
            if (this.config.type === 'Salesforce')
                return _.get(metadata, 'sobjectName');
            else
                return _.get(metadata, 'aqlName');
        }
        else {
            return undefined;
        }
    }
    getTypeByApiName(apiName) {
        const service = _.find(_.map(Array.from(_.get(this.injector, 'records', new Map()).values()), 'value'), (provider) => (typeof _.get(provider, 'type') === 'function') && this.getObjectName(_.get(provider, 'type')) === apiName);
        return _.get(service, 'type');
    }
    // Order CreatedBy.Name null
    getFieldName(ab, key) {
        const fieldParts = _.split(key, '.');
        const fieldReference = fieldParts.pop();
        let instance = (ab instanceof AObject) ? ab : new ab();
        let prefix = '';
        _.forEach(fieldParts, part => {
            prefix += this.getFieldName(instance, part) + '.';
            instance = this.getKeyInstance(instance, part);
        });
        const fields = this.getFieldMetadata(instance);
        return prefix + _.get(fields, `${fieldReference}.${(this.config.type === 'Salesforce') ? 'soql' : 'aql'}`);
    }
    getKeyName(ab, fieldName) {
        if (ab) {
            let instance;
            try {
                instance = (ab instanceof AObject) ? ab : new ab();
            }
            catch (e) {
                instance = ab;
            }
            const fields = this.getFieldMetadata(instance);
            let returnValue = undefined;
            const suffix = (this.config.type === 'Salesforce') ? 'soql' : 'aql';
            for (let field in fields) {
                if (_.get(fields, field + '.' + suffix) === fieldName) {
                    returnValue = field;
                    break;
                }
            }
            return returnValue;
        }
        else
            return undefined;
    }
    getKeyInstance(type, fieldName) {
        const instance = (type instanceof AObject) ? new type.constructor : new type();
        if (!_.isNil(fieldName)) {
            const metadata = this.getTypeMetadata(type, fieldName);
            if (_.get(metadata, 'typeFunction')) {
                const classType = metadata.typeFunction();
                return new classType();
            }
            else if (_.get(instance, fieldName) instanceof AObject)
                return new _.get(instance, fieldName);
            else if (_.get(instance, `${fieldName}[0]`))
                return _.get(instance, `${fieldName}[0]`);
        }
        else
            return instance;
    }
    getRestResource(type) {
        return _.defaultTo(_.get(this.getMetadata(type), 'route'), this.getObjectName(type));
    }
    getKeyReferenceType(type, fieldName) {
        const metadata = this.getTypeMetadata(type, fieldName);
        const instance = (type instanceof AObject) ? new type.constructor : new type();
        if (_.get(metadata, 'reflectedType') && Array.isArray(metadata.reflectedType()))
            return 'Array';
        else if (Array.isArray(_.get(instance, fieldName)) && _.get(instance, `${fieldName}[0]`) instanceof AObject)
            return 'Array';
        else if (_.get(metadata, 'typeFunction')) {
            return 'Object';
        }
        else if (_.get(instance, fieldName) instanceof AObject) {
            return 'Object';
        }
        else
            return undefined;
    }
    getMetadata(aobject) {
        const instance = (aobject instanceof AObject) ? aobject : new aobject();
        return this._reflect.getMetadata('aobject', instance.constructor);
    }
    getTypeMetadata(aobject, fieldName) {
        const classType = (aobject instanceof AObject) ? aobject.constructor : aobject;
        if (classType)
            return defaultMetadataStorage.findTypeMetadata(classType, fieldName);
        else
            return undefined;
    }
    buildTypeModel(type, describe) {
        const generator = (subType, subDescribe) => {
            const service = this.getAObjectServiceForType(subType);
            if (!_.isNil(service)) {
                const describe$ = _.isNil(subDescribe) ? service.describe() : of(subDescribe);
                return describe$
                    .pipe(tap(res => {
                    if (_.get(res, 'name') === new subType().getApiName()) {
                        const classConstructor = new subType().constructor;
                        const metadata = Reflect.getOwnMetadata('fields', classConstructor) || {};
                        const customFields = _.filter(_.get(res, 'fields', []), (field) => field.custom === true && !_.some(Object.values(metadata), y => _.lowerCase(_.get(y, 'soql')) === _.lowerCase(field.name)));
                        const createProperty = (name, soql, aic) => {
                            Object.defineProperty(subType, name, { value: null, writable: true, enumerable: true, configurable: true });
                            metadata[name] = { soql: soql, aic: aic };
                            defaultMetadataStorage.addExposeMetadata(new ExposeMetadata(subType, name, {}));
                        };
                        customFields.forEach(field => {
                            if (field.type === 'reference') {
                                const classType = this.getTypeByApiName(_.get(field, 'referenceTo[0]'));
                                if (classType) {
                                    createProperty(_.get(field, 'relationshipName'), _.get(field, 'relationshipName'));
                                    defaultMetadataStorage.addTypeMetadata({
                                        target: classConstructor,
                                        reflectedType: classType,
                                        propertyName: _.get(field, 'relationshipName'),
                                        typeFunction: () => classType,
                                        options: undefined
                                    });
                                }
                            }
                            createProperty(_.get(field, 'name'), _.get(field, 'name'));
                        });
                        Reflect.defineMetadata('fields', metadata, classConstructor);
                    }
                    return null;
                }), catchError(() => {
                    console.warn(`Couldn't generate model for ${subType.constructor.name}`);
                    return of(null);
                }), take(1));
            }
            else
                return of(null);
        };
        const obsvList = [];
        const _loop = (instance) => {
            const t = instance.getType();
            if (!_.includes(this.types, t)) {
                obsvList.push({
                    type: t,
                    obsv: (_.get(instance.getMetadata(), 'dynamic') === true) ? generator(t, describe) : of(null),
                    dynamic: _.get(instance.getMetadata(), 'dynamic') === true
                });
                _.forEach(_.filter(instance.getReferenceFields(), f => !(_.some(obsvList, (o) => _.get(o, 'type') === instance.instanceOf(f).getType()))), f => _loop(instance.instanceOf(f)));
            }
        };
        _loop(this.getKeyInstance(type));
        const dynamicList = _.filter(obsvList, o => o.dynamic === true);
        if (!_.isEmpty(dynamicList))
            return forkJoin(..._.map(dynamicList, 'obsv'))
                .pipe(tap(() => this.types = _.uniq(_.concat(this.types, _.map(obsvList, 'type')))));
        else
            return of(null);
    }
    getAObjectServiceForType(type, exactMatch = false) {
        if (_.isNil(type))
            return null;
        else {
            const instance = (type instanceof AObject) ? type : (typeof type === 'function') ? new type() : type;
            let providers = _.map(Array.from(_.get(this.injector, 'records', new Map()).values()), 'value');
            if (_.isUndefined(providers) || _.isEmpty(providers))
                providers = _.get(this.injector, '_providers', []);
            let serviceList = _.filter(providers, (provider) => _.get(provider, 'type') === type
                || _.get(provider, 'type') === type.constructor
                || (_.isFunction(_.get(provider, 'getInstance')) && provider.getInstance() instanceof type.constructor)
                || (_.get(provider, 'type') === AObject && Object.getPrototypeOf(Object.getPrototypeOf(provider)).constructor === Object));
            let typeServices = serviceList.map(service => {
                const clone = Object.create(service);
                clone.setType(instance.constructor);
                return clone;
            });
            if (exactMatch && typeServices.length < 1) {
                throw `You have attempted to use a service before it has been injected: ${_.get(type, 'name')}`;
            }
            else
                return _.last(typeServices);
        }
    }
    getReferenceFields(type) {
        const instance = new type();
        return Object.keys(this.getFieldMetadata(instance)).filter(key => this.getKeyReferenceType(type, key) === 'Array' || this.getKeyReferenceType(type, key) === 'Object');
    }
    getFieldKeys(instance) {
        return Object.keys(this.getFieldMetadata(instance));
    }
    getFieldMetadata(aobject, metadataFilter) {
        const instance = (aobject instanceof AObject) ? aobject : new aobject();
        let instanceKey;
        try {
            instanceKey = instance.generatedId();
        }
        catch (_a) {
            instanceKey = SalesforceUtils.hashCode(instance.constructor.toString());
        }
        if (!this._fieldCache[instanceKey]) {
            const _loop = (i, fieldObj = {}) => {
                const fields = Reflect.getMetadata('fields', i.constructor);
                if (fields) {
                    Object.assign(fieldObj, fields);
                    return _loop(Reflect.getPrototypeOf(i), fieldObj);
                }
                else {
                    return fieldObj;
                }
            };
            const returnList = _loop(instance);
            this._fieldCache[instanceKey] = returnList;
        }
        if (metadataFilter)
            return _.pickBy(this._fieldCache[instanceKey], metadataFilter);
        else
            return this._fieldCache[instanceKey];
    }
}
MetadataService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: MetadataService, deps: [{ token: 'configuration' }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
MetadataService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: MetadataService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: MetadataService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: Configuration, decorators: [{
                    type: Inject,
                    args: ['configuration']
                }] }, { type: i0.Injector }]; } });

class ApiService {
    constructor(configService, httpClient, sanitizer) {
        this.configService = configService;
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.onRefresh = new EventEmitter();
        this.onApiError = new EventEmitter();
        this.apiVersion = '4';
    }
    callout(method, endpoint, payload, responseType = 'json') {
        let accessToken = localStorage.getItem(PlatformConstants.ACCESS_TOKEN);
        let storefront = this.configService.get('storefront');
        let accountId = localStorage.getItem('account');
        const isRevoke = endpoint.indexOf('/users/token') >= 0 && method === 'DELETE';
        let headers = new HttpHeaders({
            'x-storefront': storefront
        });
        if (!isNil(accessToken) && !isRevoke)
            headers = headers.set('Authorization', `Bearer ${accessToken}`);
        if (!isNil(accountId))
            headers = headers.set('x-account', accountId);
        return this.httpClient.request(method, endpoint, { body: payload, responseType: responseType, headers: headers });
    }
    get(location, type, ignoreDecorators = true) {
        const sanitizedUrl = this.sanitizer.sanitize(SecurityContext.URL, location);
        return this.getEndpoint(sanitizedUrl)
            .pipe(switchMap(url => this.callout('GET', url)), retryWhen(genericRetryStrategy({
            scalingDuration: 500,
            maxRetryAttempts: 1,
            excludedStatusCodes: [500, 503],
            onError: this.onError(),
            setTokenExpired: !location.includes('/users/active'),
        })), catchError(error => of(error)), map(res => this.mapResult(res)), map(data => (!isNil(type) ? plainToClass(type, this.parseResponse(data), { ignoreDecorators: ignoreDecorators }) : this.parseResponse(data))));
    }
    post(location, payload = {}, type, retry = true, ignoreDecorators = true) {
        let post$ = this.getEndpoint(location).pipe(switchMap(url => this.callout('POST', url, payload)));
        if (retry)
            post$ = post$.pipe(retryWhen(genericRetryStrategy({
                scalingDuration: 500,
                maxRetryAttempts: 1,
                excludedStatusCodes: [500, 503],
                onError: this.onError()
            })));
        return post$.pipe(catchError(error => {
            const errorResponse = {
                error: get(error, 'error'),
                requestPayload: payload
            };
            this.onApiError.emit(errorResponse);
            return throwError(errorResponse);
        }), map(res => this.mapResult(res)), map(data => (!isNil(type) ? plainToClass(type, this.parseResponse(data), { ignoreDecorators: ignoreDecorators }) : this.parseResponse(data))));
    }
    put(location, payload = {}, type, ignoreDecorators = true) {
        const sanitizedUrl = this.sanitizer.sanitize(SecurityContext.URL, location);
        return this.getEndpoint(sanitizedUrl)
            .pipe(switchMap(url => this.callout('PUT', url, payload)), map(res => this.mapResult(res)), map(data => (!isNil(type) ? plainToClass(type, this.parseResponse(data), { ignoreDecorators: ignoreDecorators }) : this.parseResponse(data))));
    }
    patch(location, payload = {}, type, ignoreDecorators = true) {
        const sanitizedUrl = this.sanitizer.sanitize(SecurityContext.URL, location);
        return this.getEndpoint(sanitizedUrl)
            .pipe(switchMap(url => this.callout('PATCH', url, payload)), map(res => this.mapResult(res)), map(data => (!isNil(type) ? plainToClass(type, this.parseResponse(data), { ignoreDecorators: ignoreDecorators }) : this.parseResponse(data))));
    }
    delete(location, type, ignoreDecorators = true) {
        const sanitizedUrl = this.sanitizer.sanitize(SecurityContext.URL, location);
        return this.getEndpoint(sanitizedUrl)
            .pipe(switchMap(url => this.callout('DELETE', url)), map(res => this.mapResult(res)), map(data => (!isNil(type) ? plainToClass(type, data, { ignoreDecorators: ignoreDecorators }) : data)));
    }
    refreshToken(username, password) {
        if (localStorage.getItem(PlatformConstants.ACCESS_TOKEN) && arguments.length === 0) {
            return of(null);
        }
        let attempts = 0;
        return this.encryptCredentials(username, password).pipe(switchMap((credentials) => this.post(`/users/token`, credentials, null, false)), retryWhen(errors => errors.pipe(map(error => {
            attempts += 1;
            if (get(error, 'status') === 400 || attempts >= 2)
                throw error;
            else {
                localStorage.removeItem(PlatformConstants.ACCESS_TOKEN);
                localStorage.removeItem(PlatformConstants.USER_INFO);
                return error;
            }
        }))), tap(creds => {
            if (!isNil(get(creds, 'accessToken'))) {
                localStorage.setItem(PlatformConstants.ACCESS_TOKEN, creds.accessToken);
                this.onRefresh.emit(creds.accessToken);
                if (!isNil(get(creds, 'LoginURL'))) {
                    const authenticationUrl = decodeURIComponent(get(creds, 'LoginURL'));
                    let url = authenticationUrl.replace('#URL#', encodeURIComponent(window.location.toString()));
                    url = `${this.configService.endpoint()}/secur/logout.jsp?retUrl=${encodeURIComponent(url)}`;
                    setTimeout(() => window.location.replace(url));
                }
            }
        }));
    }
    revokeToken() {
        const token = localStorage.getItem(PlatformConstants.ACCESS_TOKEN);
        if (isNil(token))
            return of(false);
        else {
            return this.delete(`/users/token/${token}`)
                .pipe(catchError(() => of(true)), tap(success => {
                if (success)
                    localStorage.removeItem(PlatformConstants.ACCESS_TOKEN);
            }));
        }
    }
    parseResponse(data) {
        forEach(data, (value, key) => {
            const objects = isObject(value) && !isNil(get(value, 'records')) ? value : null;
            if (isObject(value))
                this.parseResponse(value);
            if (objects) {
                this.parseResponse(get(objects, 'records'));
                set(data, key, get(objects, 'records'));
            }
        });
        return data;
    }
    encryptCredentials(username, password) {
        if (isNil(username) || isNil(password))
            return of(null);
        else {
            return this.getAuthKey().pipe(switchMap(key => {
                // Initialization Vector for CBC algorithm
                const iv = window.crypto.getRandomValues(new Uint8Array(16));
                // Raw customer credential data
                const clientCredentials = {
                    key: username,
                    value: password
                };
                // Supporting function to convert the hex key into an ArrayBuffer object
                const hexToArrayBuffer = hex => {
                    const typedArray = new Uint8Array(hex.match(/[\da-f]{2}/gi).map(function (h) {
                        return parseInt(h, 16);
                    }));
                    return typedArray.buffer;
                };
                // Supporting function converts a string into an ArrayBuffer
                const getUtf8Bytes = str => new Uint8Array([...unescape(encodeURIComponent(str))].map(c => c.charCodeAt(0)));
                return from(crypto.subtle
                    .importKey('raw', hexToArrayBuffer(key), {
                    // this is the algorithm options
                    name: 'AES-CBC',
                    length: 256
                }, false, // whether the key is extractable (i.e. can be used in exportKey)
                ['encrypt', 'decrypt'] // key can be used for encryption and decryption
                )
                    .then(keyImport => {
                    return crypto.subtle.encrypt({
                        name: 'AES-CBC',
                        // Don't re-use initialization vectors!
                        // Always generate a new iv every time your encrypt!
                        iv: iv,
                        length: 256
                    }, keyImport, // CryptoKey object generated from hex key
                    getUtf8Bytes(JSON.stringify(clientCredentials)) // ArrayBuffer of client credentials
                    );
                })
                    .then(encrypted => {
                    // The result from the promise will contain encrypted customer credentials.
                    // In order to decrypt the request, the IV used must be prepended to the body
                    const requestData = btoa(String.fromCharCode(...iv) +
                        String.fromCharCode(...new Uint8Array(encrypted)));
                    return requestData;
                }));
            }));
        }
    }
    mapResult(result) {
        return get(result, 'data');
    }
    getEndpoint(location) {
        location = this.sanitizer.sanitize(SecurityContext.URL, location);
        if (!startsWith(location, '/'))
            location = '/' + location;
        const packageNamespace = !isNil(this.configService.get('packageNamespace')) ? `${this.configService.get('packageNamespace')}/` : '';
        const endpoint = `${this.configService.endpoint()}/services/apexrest/${packageNamespace}apttus/v${this.apiVersion}${location}`;
        return of(endpoint);
    }
    getAuthKey() {
        return this.get('/users/key');
    }
    onError() {
        return this.revokeToken()
            .pipe(switchMap(() => this.refreshToken()));
    }
}
ApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ApiService, deps: [{ token: ConfigurationService }, { token: i1$1.HttpClient }, { token: i2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Injectable });
ApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: ConfigurationService }, { type: i1$1.HttpClient }, { type: i2.DomSanitizer }]; } });
const genericRetryStrategy = ({ maxRetryAttempts = 3, scalingDuration = 1000, excludedStatusCodes = [], onError = null, setTokenExpired = true, } = {}) => (attempts) => {
    return attempts.pipe(mergeMap((error, i) => {
        const retryAttempt = i + 1;
        // if maximum number of retries have been met
        // or response is a status code we don't wish to retry, throw error
        if (error.status === 0 && !error.body && localStorage.getItem(PlatformConstants.ACCESS_TOKEN)) {
            if (setTokenExpired)
                localStorage.setItem(PlatformConstants.TOKEN_EXPIRED, JSON.stringify(true));
            localStorage.removeItem(PlatformConstants.ACCESS_TOKEN);
            window.location.reload();
            return throwError(error);
        }
        if (retryAttempt > maxRetryAttempts ||
            excludedStatusCodes.find(e => e === error.status)) {
            return throwError(error);
        }
        else {
            if (error.name === 'HttpErrorResponse' && onError)
                return onError.pipe(switchMap(() => timer(retryAttempt * scalingDuration)));
            else
                return timer(retryAttempt * scalingDuration);
        }
    }), finalize(() => console.log('Api Callout Done')));
};

let _windowConfig = window.sv || {};
class PlatformService {
    constructor(httpClient, _cache, metadataService, config, apiService) {
        this.httpClient = httpClient;
        this._cache = _cache;
        this.metadataService = metadataService;
        this.config = config;
        this.apiService = apiService;
        this.loginChange = new ReplaySubject();
        this.loggingIn = false;
        this.stopOnException = false;
        this.onLogout = new EventEmitter();
        this.recordMap = {};
        let proxyLogin = this.config.get('proxy');
        if (proxyLogin && !proxyLogin.endsWith('/'))
            proxyLogin += '/';
        else if (!proxyLogin)
            proxyLogin = '';
        const organizationId = (this.config.get('organizationId') ? this.config.get('organizationId') : _windowConfig.organizationId);
        JSForceService.fixSoapLogin(jsforce, organizationId, this.config.proxyEndpoint());
        JSForceService.fixIdentity(jsforce, this.config.proxyEndpoint());
        JSForceService.addSoapCallout(jsforce, this.config.get('production'));
        // JSForceService.fixPrompt(jsforce);
        JSForceService.fixLogout(jsforce);
        // Generate search params for url fragment
        const fragmentParams = new URLSearchParams(window.location.hash.substring(1));
        // If access token is in visualforce page
        if (_windowConfig && _windowConfig.accessToken && _windowConfig.accessToken !== 'NULL_SESSION_ID') {
            localStorage.setItem(PlatformConstants.ACCESS_TOKEN, _windowConfig.accessToken);
        }
        // If access token is in url fragment
        else if (!_.isNil(fragmentParams.get(PlatformConstants.ACCESS_TOKEN))) {
            localStorage.setItem(PlatformConstants.ACCESS_TOKEN, fragmentParams.get(PlatformConstants.ACCESS_TOKEN));
        }
        this.apiService.onRefresh.subscribe(token => this.setAccessToken(token));
        this.resetConnection();
    }
    static lengthInBytes(str) {
        if (!_.isNil(str)) {
            const m = encodeURIComponent(str).match(/%[89ABab]/g);
            return str.length + (m ? m.length : 0);
        }
        else
            return 0;
    }
    setPassword(password) {
        return this.userId().pipe(flatMap(userId => {
            return this.connection.soap.setPassword(userId, password);
        }));
    }
    getConnection() {
        return this.connection;
    }
    login(username, password) {
        if (!username || !password) {
            let credentialKey = localStorage.getItem(PlatformConstants.KEY);
            if (credentialKey) {
                let storedCredentials = JSON.parse(atob(credentialKey));
                if (storedCredentials && storedCredentials.username && storedCredentials.password)
                    return this.doLogin(storedCredentials.username, storedCredentials.password);
                else
                    return throwError(new Error('Invalid Login'));
            }
            else {
                return throwError(new Error('Invalid Login'));
            }
        }
        else {
            return this.doLogin(username, password);
        }
    }
    loginOauth() {
        jsforce.browser.init({
            clientId: this.config.get('connectedApp.clientId'),
            redirectUri: this.config.get('connectedApp.redirectUri', this.config.resourceLocation()),
            loginUrl: this.config.endpoint()
        });
        jsforce.browser.login();
    }
    logout() {
        let isTokenExpired = false;
        return this.apiService.revokeToken()
            .pipe(catchError(() => of(null)), tap(success => {
            isTokenExpired = localStorage.getItem(PlatformConstants.TOKEN_EXPIRED) === 'true';
            localStorage.clear();
            if (isTokenExpired)
                localStorage.setItem(PlatformConstants.TOKEN_EXPIRED, JSON.stringify(isTokenExpired));
            if (_windowConfig)
                delete _windowConfig.accessToken;
            delete this.connection;
            this.resetConnection();
            this.onLogout.emit(true);
            this._cache.refresh('User');
        }));
    }
    setAccessToken(accessToken) {
        if (!_.isNil(accessToken)) {
            this.connection.accessToken = accessToken;
            localStorage.setItem(PlatformConstants.ACCESS_TOKEN, accessToken);
        }
        else {
            delete this.connection.accessToken;
            localStorage.removeItem(PlatformConstants.ACCESS_TOKEN);
        }
    }
    setUserInfo(userInfo) {
        this.connection.instanceUrl = userInfo.instance_url;
        localStorage.setItem(PlatformConstants.USER_INFO, JSON.stringify(userInfo));
    }
    isLoggedIn() {
        return (this.connection && this.connection.accessToken) ? true : false;
    }
    isGuest() {
        return of(!this.connection.accessToken);
    }
    create(objectList, objectType, updateCache) {
        const apiName = new objectType().getApiName();
        return this.apiService.post(apiName, objectList, objectType)
            .pipe(map((res) => res.map(a => _.get(a, 'Id', _.get(a, 'id')))));
    }
    remove(objectList, objectType, updateCache) {
        const apiName = new objectType().getApiName();
        return this.apiService.post(`${apiName}/delete`, objectList).pipe(map((res) => res.map(a => _.get(a, 'Id', _.get(a, 'id')))));
    }
    update(objectList, objectType, updateCache) {
        const apiName = new objectType().getApiName();
        return this.apiService.put(apiName, objectList, objectType).pipe(map((res) => res.map(a => _.get(a, 'Id', _.get(a, 'id')))));
    }
    upsert(objectList, objectType, updateCache) {
        const apiName = new objectType().getApiName();
        return this.apiService.put(apiName, objectList, objectType).pipe(map((res) => res.map(a => _.get(a, 'Id', _.get(a, 'id')))));
    }
    composite(dataList) {
        return this.post('composite', { 'q': dataList.filter(d => d.data && d.method && d.sobjectType) }).pipe(take(1));
    }
    callout(url, method = 'GET', body) {
        return from(this.getConnection().request({
            method: method,
            url: url,
            body: body
        }));
    }
    post(method, data, classOverride = 'DataHandler', anonymous = false, count = 0, namespace = this.config.get('packageNamespace')) {
        const body = {
            class: classOverride,
            method: method,
            data: data,
            encryptedResponse: this.config.get('encryptResponse'),
            namespace: namespace
        };
        const start = new Date().getTime();
        const location = !_.isNil(this.config.get('packageNamespace')) ? `/${this.config.get('packageNamespace')}/dc/` : '/dc/';
        const connection = (anonymous) ? this.anonymousConnection : this.connection;
        return this._cache.encrypt(body)
            .pipe(mergeMap(payload => from(connection.apex.post(location + start, { d: payload }))
            .pipe(mergeMap((res) => (this.config.get('encryptResponse')) ? this._cache.decrypt(res) : of(JSON.parse(res))), map((res) => {
            const end = new Date().getTime();
            if (res && res.success) {
                this.logRequest(payload, body, (end - start), res);
                try {
                    return JSON.parse(res.data);
                }
                catch (e) {
                    return (res.data) ? res.data : res;
                }
            }
            else {
                throw (res && res.data) ? res.data : null;
            }
        }), catchError(e => {
            const end = new Date().getTime();
            this.logRequest(payload, body, (end - start));
            if (PlatformService.STOP_EXCEPTIONS.indexOf(e.name) >= 0 && count <= 2 && !_.isNil(this.connection.accessToken)) {
                count += 1;
                return this.logout().pipe(switchMap(() => this.post(method, data, classOverride, false, count)));
            }
            else
                return throwError(e);
        }))), take(1));
    }
    logRequest(payload, body, requestTime, response) {
        if (this.config.get('production') !== true) {
            if ((this.config.get('enableQueryLogs') === true && body) || (this.config.get('enablePerformanceLogs') === true && requestTime)) {
                // tslint:disable-next-line:no-console
                console.debug('-------------------------------');
                if (this.config.get('enableQueryLogs') === true) {
                    // tslint:disable-next-line:no-console
                    console.debug(body);
                    if (_.get(body, 'data.q'))
                        // tslint:disable-next-line:no-console
                        console.debug(`Objects ${_.uniq(_.map(_.values(_.get(body, 'data.q')), a => _.get(a, 'type')))}`);
                    if (!_.isNil(response)) {
                        let responseData = response.data;
                        try {
                            responseData = JSON.parse(_.get(response, 'data', '{}'));
                        }
                        catch (e) {
                            // suppress
                        }
                        finally {
                            _.forEach(responseData, recordSet => _.forEach(recordSet, r => {
                                if (!_.isNil(_.get(r, 'Id')))
                                    _.set(this.recordMap, _.get(r, 'Id'), _.get(this.recordMap, _.get(r, 'Id'), 0) + 1);
                            }));
                            const max = _.findKey(this.recordMap, o => _.max(_.values(this.recordMap)) === o);
                            // tslint:disable-next-line:no-console
                            console.debug(`Record with id ${max} has been queried for ${_.get(this.recordMap, max)} times`);
                        }
                    }
                }
                if (this.config.get('enablePerformanceLogs')) {
                    // tslint:disable-next-line:no-console
                    console.debug(`Type: ${body.method}    Input: ${PlatformService.lengthInBytes(payload)} bytes    Output: ${PlatformService.lengthInBytes(JSON.stringify(response))} bytes    Time: ${requestTime} milliseconds`);
                }
            }
        }
    }
    query(options, type, parse = false) {
        const apiName = new type().getApiName();
        if (parse)
            return this.apiService.post(`/${apiName}/query`, options, type);
        else
            return this.apiService.post(`/${apiName}/query`, options);
    }
    checkChildren(data) {
        let obsvArray = [];
        for (let record of data.records) {
            for (const property in record) {
                if (record.hasOwnProperty(property) && record[property].done === false)
                    obsvArray.push(this.queryMore(record[property].nextRecordsUrl, record[property], record, property));
            }
        }
        if (obsvArray && obsvArray.length > 0)
            return forkJoin(obsvArray);
        else
            return of(data);
    }
    queryMore(locator, data, parent, parentProperty) {
        return from(this.connection.queryMore(locator)).pipe(flatMap((res) => {
            res.records = res.records.concat(data.records);
            if (parent && parent[parentProperty])
                parent[parentProperty] = res;
            if (res.done === false)
                return this.queryMore(res.nextRecordsUrl, res, parent, parentProperty);
            else
                return of(res);
        }));
    }
    describe(sobject, fieldName, picklistOnly) {
        return this.apiService.get(`${sobject}/describe`).pipe(map(_.first));
    }
    userId() {
        if (localStorage.getItem(PlatformConstants.USER_INFO)) {
            const userInfo = JSON.parse(localStorage.getItem(PlatformConstants.USER_INFO));
            const id = _.get(userInfo, 'id', '');
            return of(id.substring(id.lastIndexOf('/') + 1));
        }
        else {
            // return this.post('identity', {});
            return this.getUserData()
                .pipe(map(data => data.userId));
        }
    }
    getUserData(username, password) {
        return this.post('getAccessToken', {
            storefrontName: this.config.get('storefront'),
            key: username,
            value: password
        })
            .pipe(tap(data => {
            if (!_.isNil(data))
                this.setAccessToken(data.accessToken);
        }));
    }
    organizationId() {
        return this.post('organization', {});
    }
    resetConnection() {
        let instanceUrl = 'https://' + window.location.hostname + window.location.pathname;
        if (_.get(_windowConfig, 'baseURL', '').trim().length > 0) {
            instanceUrl = 'https://' + _windowConfig.baseURL;
        }
        else if (_.get(_windowConfig, 'salesforceEndpoint', '').trim().length > 0) {
            instanceUrl = 'https://' + _windowConfig.salesforceEndpoint + window.location.pathname;
        }
        else {
            instanceUrl = this.config.endpoint();
        }
        const args = {
            loginUrl: instanceUrl,
            instanceUrl: instanceUrl,
            serverUrl: instanceUrl
        };
        this.connection = new jsforce.Connection(args);
        this.anonymousConnection = new jsforce.Connection(args);
        // Set the access Token
        this.connection.accessToken = localStorage.getItem(PlatformConstants.ACCESS_TOKEN);
    }
    doLogin(username, password) {
        return this.apiService.refreshToken(username, password);
    }
}
PlatformService.STOP_EXCEPTIONS = ['INVALID_SESSION_ID', 'API_CURRENTLY_DISABLED', 'ERROR_HTTP_403', 'ERROR_HTTP_504', 'ERROR_HTTP_400'];
PlatformService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PlatformService, deps: [{ token: i1$1.HttpClient }, { token: CacheService }, { token: MetadataService }, { token: ConfigurationService }, { token: ApiService }], target: i0.ɵɵFactoryTarget.Injectable });
PlatformService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PlatformService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PlatformService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: CacheService }, { type: MetadataService }, { type: ConfigurationService }, { type: ApiService }]; } });

class AObjectService {
    constructor(cacheService, platformService, metadataService, configurationService, injector) {
        this.cacheService = cacheService;
        this.platformService = platformService;
        this.metadataService = metadataService;
        this.configurationService = configurationService;
        this.injector = injector;
        this.customFields = [];
        this.defaultImplementationNoProvided = 'Default implementation is not provided';
        this.type = AObject;
        setTimeout(() => this.onInit());
    }
    static arrayToCsv(idArray) {
        if (!idArray || idArray.length === 0)
            return null;
        else {
            let result = ``;
            for (const key of idArray) {
                result += `'` + key + `',`;
            }
            if (result.indexOf(',') > -1)
                result = result.substring(0, result.lastIndexOf(','));
            return result;
        }
    }
    onInit() { }
    onWhere(records) {
        return of(records);
    }
    getInstance() {
        if (!this.type)
            throw new Error('AObject service missing type');
        else
            return new this.type();
    }
    setType(type) {
        this.type = type;
    }
    globalFilter() {
        return of(null);
    }
    globalJoin() {
        return of(null);
    }
    globalCriteria() {
        return of(null);
    }
    getChildConditions() {
        const instance = new this.type();
        const obsvList = _.compact(_.map(instance.getReferenceFields('Child'), key => {
            const childType = instance.instanceOf(key);
            try {
                const service = this.metadataService.getAObjectServiceForType(childType, true);
                const modelFilter = _.get(instance.getMetadata(key), 'filter');
                return service.globalFilter()
                    .pipe(map(globalFilter => {
                    return new AChildFilter(key, _.concat(globalFilter, modelFilter));
                }));
            }
            catch (e) {
                return of(null);
            }
        }));
        if (_.isEmpty(obsvList))
            return of(null);
        else
            return combineLatest(...obsvList);
    }
    getLookups(instance, depth = 0, deep = true) {
        const replace = (field) => field.replace('__r', '__c');
        const referenceField = instance.hasExpose() ? instance.getReferenceFieldsFromExpose('Lookup') : instance.getReferenceFields('Lookup');
        if (!_.isEmpty(referenceField) && depth <= this.configurationService.get('expandDepth')) {
            return _.map(referenceField, l => {
                const expand = _.get(instance.getMetadata(l), 'expand') === 'deep' && deep;
                return {
                    field: replace(instance.getApiName(l)),
                    lookups: this.getLookups(instance.instanceOf(l), depth + 1, expand),
                    children: expand ? this.getChildren(instance.instanceOf(l), null, depth, expand) : null
                };
            });
        }
        else
            return null;
    }
    getChildren(instance, filters, depth = 0, deep = true) {
        depth += 1;
        const referenceField = instance.hasExpose() ? instance.getReferenceFieldsFromExpose('Child') : instance.getReferenceFields('Child');
        if (!_.isEmpty(referenceField) && depth <= this.configurationService.get('expandDepth') && deep) {
            return _.map(referenceField, c => ({
                field: instance.getApiName(c),
                filters: _.compact(_.first(_.map(_.filter(filters, { field: c }), 'filterList'))),
                children: this.getChildren(instance.instanceOf(c), null, depth, _.get(instance.getMetadata(c), 'expand') === 'deep' && deep),
                lookups: this.getLookups(instance.instanceOf(c), depth, _.get(instance.getMetadata(c), 'expand') === 'deep' && deep)
            }));
        }
        else
            return null;
    }
    getRestResource() {
        return this.metadataService.getRestResource(this.type);
    }
    query(queryOptions) {
        const options = _.assign({
            expressionOperator: 'AND',
            aggregate: false,
            skipCache: false,
            view: 'detail',
            expand: true,
            cacheStrategy: 'freshness',
            alias: true
        }, queryOptions);
        // Generic query check
        if (_.isEmpty(_.get(options, 'conditions'))
            && _.isEmpty(_.get(options, 'filters'))
            && _.isEmpty(_.get(options, 'joins'))
            && _.isNil(_.get(options, 'page.pageLimit'))
            && _.isNil(_.get(options, 'groupBy'))
            && !options.aggregate
            && _.trim(_.get(options, 'searchString', '')).length < 2) {
            return throwError('Your query is too generic, you must provide filter conditions or a limit');
        }
        // Return empty array if using 'in' operator on empty set
        else if (
        // There exists a condition
        _.some(_.get(options, 'conditions'), 
        // Such that the condition value is undefined
        condition => _.isUndefined(_.get(condition, 'val'))
            // Or the condition value is an array and the array is empty or only contains undefined values
            || (_.isArray(_.get(condition, 'val'))
                && _.isEmpty(_.filter(_.get(condition, 'val'), v => !_.isNil(v)))))) {
            return of([]);
        }
        else {
            const globals$ = combineLatest(this.globalFilter(), this.globalJoin(), this.globalCriteria(), this.getChildConditions());
            const queryFn = ([globalFilters, globalJoins, globalCriteria, childConditions]) => {
                const instance = this.getInstance();
                _.set(options, 'filters', _.compact(_.concat(_.get(options, 'filters'), globalFilters)));
                _.set(options, 'conditions', _.compact(_.concat(_.get(options, 'conditions'), globalCriteria)));
                if (_.get(options, 'view') === 'detail') {
                    // Set lookups if nil.
                    _.isNil(_.get(options, 'lookups')) && _.set(options, 'lookups', this.getLookups(instance));
                    // Set children if nil.
                    _.isNil(_.get(options, 'children')) && _.set(options, 'children', _.defaultTo(options.children, this.getChildren(instance, childConditions, 0, _.get(options, 'expand') === true)));
                }
                let joins = _.compact(_.concat(_.get(options, 'joins'), globalJoins));
                _.set(options, 'joins', _.unionBy(joins, joins, 'apiName'));
                // Aggregate fields
                let fieldArray = new Array();
                const aggregateFields = instance.getFieldMetadata(m => !_.isNil(_.get(m, 'aggregate')));
                _.forEach(_.keys(aggregateFields), (field) => {
                    _.forEach(_.get(aggregateFields, `${field}.aggregate`), aggregateType => {
                        fieldArray.push({
                            field: field,
                            aggregateType: aggregateType
                        });
                    });
                });
                _.set(options, 'aggregateFields', fieldArray);
                const apiName = this.getInstance().getApiName();
                return this.platformService.apiService.post(`/${apiName}/query`, options, _.get(options, 'aggregate') !== true ? this.type : undefined, true, _.get(options, 'alias') !== false);
            };
            return globals$
                .pipe(switchMap(globalValues => queryFn(globalValues)));
        }
    }
    where(conditionList, expressionOperator = 'AND', filterList, sortOrder, pageInfo, joinList, noCache = false) {
        return this.query({
            conditions: conditionList,
            expressionOperator: expressionOperator,
            filters: filterList,
            sortOrder: sortOrder,
            page: pageInfo,
            joins: joinList,
            skipCache: noCache
        });
    }
    search(searchString, conditionList, expressionOperator = 'AND', filterList, sortOrder, pageInfo, joinList) {
        return this.query({
            searchString: searchString,
            conditions: conditionList,
            expressionOperator: expressionOperator,
            filters: filterList,
            sortOrder: sortOrder,
            page: pageInfo,
            joins: joinList
        });
    }
    aggregate(conditionList, expressionOperator = 'AND', filterList, joinList) {
        return this.query({
            aggregate: true,
            skipCache: true,
            conditions: conditionList,
            expressionOperator: expressionOperator,
            filters: filterList,
            joins: joinList
        });
    }
    describeObject(entity) {
        const entityClass = (entity != null) ? entity : this.type;
        const subject = new BehaviorSubject(null);
        const apiObjectName = new entityClass().getApiName();
        this.platformService.describe(apiObjectName, null, null)
            .pipe(take(1))
            .subscribe(d => subject.next(d));
        return subject.pipe(filter(data => !_.isNil(data)));
    }
    describe(entity, field, picklistOnly = false, useGobalDescribe = false) {
        const entityClass = (entity != null) ? entity : this.type;
        let fieldApiName, apiName;
        apiName = new entityClass().getApiName(field);
        fieldApiName = (apiName === 'undefined') ? field : apiName;
        return this.describeObject(entity)
            .pipe(map(data => (!_.isNil(field)) ? _.find(_.get(data, 'fields', []), (f) => _.toLower(f.name) === _.toLower(_.trim(fieldApiName))) : data));
    }
    get(idList, cache = true) {
        idList = _.compact(idList);
        if (!_.every(idList, id => typeof id === 'string')) {
            throw `Only string values may be used for get(), found ${idList}`;
        }
        else if (!_.isEmpty(idList))
            return this.query({
                conditions: [new ACondition(this.type, 'Id', 'In', idList.filter(id => id != null && id.trim().length >= 15))],
                skipCache: !cache
            });
        else
            return of([]);
    }
    fetch(id) {
        const lookups = _.map(this.getLookups(this.getInstance()), 'field');
        const children = _.map(this.getChildren(this.getInstance()), 'field');
        const lookupParam = (!_.isEmpty(lookups)) ? `&lookups=${encodeURIComponent(_.join(lookups, ','))}` : '';
        const childrenParam = (!_.isEmpty(children)) ? `&children=${encodeURIComponent(_.join(children, ','))}` : '';
        const route = _.defaultTo(_.get(this.getInstance().getMetadata(), 'route'), this.getInstance().getApiName());
        const subject = new BehaviorSubject(null);
        this.platformService.apiService.get(`/${route}/${id}?cacheStrategy=performance${lookupParam}${childrenParam}`, this.type)
            .pipe(take(1))
            .subscribe(data => subject.next(data));
        return subject.pipe(filter(d => !_.isNil(d)));
    }
    delete(recordList, updateCache = true) {
        return this.constructiveOperation(recordList, _.bind(this.platformService.remove, this.platformService), updateCache, 'delete');
    }
    create(objectList, updateCache = true) {
        return this.constructiveOperation(objectList, _.bind(this.platformService.create, this.platformService), updateCache, 'create');
    }
    update(recordList, updateCache = true) {
        return this.constructiveOperation(recordList, _.bind(this.platformService.update, this.platformService), updateCache, 'update');
    }
    upsert(recordList, updateCache = true) {
        return this.constructiveOperation(recordList, _.bind(this.platformService.upsert, this.platformService), updateCache, 'upsert');
    }
    generateModel() {
        throw 'Method is deprecated, set the dynamic attribute on the ATable decorator of your model to true';
    }
    toApiJson(recordList) {
        const adtlRecords = new Array();
        recordList = _.map(_.compact(recordList), (record) => {
            if (record.hasExpose())
                return record.toApiJsonFromExpose(this.configurationService.platform());
            else
                return record.toApiJson(this.configurationService.platform());
        });
        return adtlRecords.concat(recordList);
    }
    constructiveOperation(recordList, callout, updateCache = true, key) {
        const records = _.filter(_.compact(recordList), a => a instanceof AObject);
        if (!_.isEmpty(records)) {
            return this.cacheService.buffer(_.first(records).generatedId() + key + updateCache, records, (items) => {
                const flatItems = _.uniqWith(_.flatten(items), (a, b) => _.get(b, 'Id') !== null && _.get(b, 'Id') === _.get(a, 'Id'));
                return callout(this.toApiJson(flatItems), this.type, updateCache)
                    .pipe(map(idArray => {
                    _.forEach(flatItems, (i, index) => _.set(i, 'Id', _.get(idArray, `[${index}]`)));
                    if (updateCache)
                        this.cacheService.onDML(flatItems);
                    return flatItems;
                }));
            }, null, null, null, true);
        }
        else
            return of(null);
    }
}
AObjectService.defaultFields = ['Id', 'CreatedDate', 'LastModifiedDate', 'LastModifiedById', 'CreatedById'];
AObjectService.currencyFields = ['DefaultCurrencyIsoCode', 'CurrencyIsoCode', 'CountryCode', 'StateCode'];
AObjectService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AObjectService, deps: [{ token: CacheService }, { token: PlatformService }, { token: MetadataService }, { token: ConfigurationService }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
AObjectService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AObjectService, providedIn: 'root' });
__decorate([
    Memoize(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Observable)
], AObjectService.prototype, "describeObject", null);
__decorate([
    MemoizeAll(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Observable)
], AObjectService.prototype, "fetch", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AObjectService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: CacheService }, { type: PlatformService }, { type: MetadataService }, { type: ConfigurationService }, { type: i0.Injector }]; }, propDecorators: { describeObject: [], fetch: [] } });

class SoapService {
    constructor(http, platformService) {
        this.http = http;
        this.platformService = platformService;
        this.envelope = `<?xml version='1.0' encoding='utf-8'?>
    <env:Envelope xmlns:env='http://schemas.xmlsoap.org/soap/envelope/' xmlns:urn='http://soap.sforce.com/schemas/class/{{class}}'>
      <env:Header>
        <urn:SessionHeader>
          <urn:sessionId>{{sessionId}}</urn:sessionId>
        </urn:SessionHeader>
      </env:Header>
      <env:Body>
        <urn:{{method}}>
        	{{body}}
        </urn:{{method}}>
      </env:Body>
    </env:Envelope>
  `;
    }
    static getBody(body, response) {
        if (!response)
            response = '';
        if (Array.isArray(body) || typeof body === 'object') {
            for (const key in body) {
                if (Array.isArray(body[key])) {
                    for (const x in body[key]) {
                        if (!SoapService.isFunction(body[key][x])) {
                            response += '<urn:' + key + '>';
                            response += SoapService.getBody(body[key][x], null);
                            response += '</urn:' + key + '>';
                        }
                    }
                }
                else if (typeof body[key] === 'object' && !SoapService.isFunction(body[key])) {
                    response += '<urn:' + key + '>' + SoapService.getBody(body[key], null) + '</urn:' + key + '>';
                }
                else {
                    response += '<urn:' + key + '>' + body[key] + '</urn:' + key + '>';
                }
            }
        }
        else {
            return body;
        }
        return response;
    }
    static iterate(obj) {
        for (const property in obj) {
            let toDel = false;
            if (property.indexOf(':') > -1) {
                const newProp = property.substring(property.lastIndexOf(':') + 1);
                obj[newProp] = obj[property];
                toDel = true;
            }
            if (obj.hasOwnProperty(property)) {
                if (typeof obj[property] === 'object')
                    SoapService.iterate(obj[property]);
            }
            if (toDel)
                delete obj[property];
        }
        return obj;
    }
    static isFunction(functionToCheck) {
        const getType = {};
        return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
    }
    doRequest(_class, method, body, anonymous = false) {
        let base = this.envelope;
        base = base.replace(new RegExp('{{class}}', 'g'), _class);
        base = base.replace(new RegExp('{{method}}', 'g'), method);
        if (anonymous)
            base = base.replace(new RegExp('{{sessionId}}', 'g'), '');
        else
            base = base.replace(new RegExp('{{sessionId}}', 'g'), this.platformService.getConnection().accessToken);
        let bodyStr = '';
        bodyStr += SoapService.getBody(body, null);
        base = base.replace('{{body}}', bodyStr);
        return from(this.platformService.getConnection().requestSoap('/services/Soap/class/' + _class, base, method)).pipe(catchError(exc => {
            try {
                const obj = SoapService.iterate(parser.xml2js(exc.message, { compact: true }));
                return throwError(_.get(obj, 'Envelope.Body.Fault.faultstring._text', obj));
            }
            catch (e) {
                return throwError(exc);
            }
        }), map((res) => {
            let jsonResponse = SoapService.iterate(res);
            if (jsonResponse.Envelope && jsonResponse.Envelope.Body && jsonResponse.Envelope.Body[method + 'Response'] && jsonResponse.Envelope.Body[method + 'Response'].result)
                return jsonResponse.Envelope.Body[method + 'Response'].result;
            else
                return jsonResponse;
        }));
    }
}
SoapService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SoapService, deps: [{ token: i1$1.HttpClient }, { token: PlatformService }], target: i0.ɵɵFactoryTarget.Injectable });
SoapService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SoapService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SoapService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: PlatformService }]; } });

class ApttusModule {
}
ApttusModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ApttusModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ApttusModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ApttusModule, declarations: [ImagePipe, FileSizePipe, TruncatePipe], imports: [CommonModule,
        HttpClientModule, i1$2.TranslateModule], exports: [ImagePipe, FileSizePipe, TruncatePipe, TranslateModule] });
ApttusModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ApttusModule, providers: [
        { provide: ErrorHandler, useClass: RavenErrorHandler }
    ], imports: [[
            CommonModule,
            HttpClientModule,
            TranslateModule.forChild()
        ], TranslateModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ApttusModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        HttpClientModule,
                        TranslateModule.forChild()
                    ],
                    declarations: [
                        ImagePipe, FileSizePipe, TruncatePipe
                    ],
                    exports: [
                        ImagePipe, FileSizePipe, TruncatePipe, TranslateModule
                    ],
                    providers: [
                        { provide: ErrorHandler, useClass: RavenErrorHandler }
                    ]
                }]
        }] });

class AuthProviderInterceptor {
    constructor(platformService) {
        this.platformService = platformService;
        this.providerName = 'Dynamics';
    }
    get accessToken() {
        if (!_.isNil(this._accessToken))
            return of(this._accessToken);
        else
            return this.platformService.post('getAccessToken', { provider: this.providerName }, 'AuthDispatcher', false, 0, '')
                .pipe(tap(token => this._accessToken = token));
    }
    intercept(request, next) {
        return this.accessToken
            .pipe(switchMap(accessToken => {
            request = request.clone({ headers: request.headers.set('Authorization', `Bearer ${accessToken}`) });
            return next.handle(request)
                .pipe(catchError(e => {
                if (e.status === 401) {
                    return this.refreshToken().pipe(switchMap(newToken => {
                        request = request.clone({ headers: request.headers.set('Authorization', `Bearer ${newToken}`) });
                        return next.handle(request);
                    }));
                }
                else {
                    return throwError(e);
                }
            }));
        }));
    }
    refreshToken() {
        return this.platformService.post('refreshToken', { provider: this.providerName, accessToken: this._accessToken }, 'AuthDispatcher', false, 0, '')
            .pipe(map(data => _.get(data, 'AccessToken')), tap(token => this._accessToken = token));
    }
}
AuthProviderInterceptor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AuthProviderInterceptor, deps: [{ token: PlatformService }], target: i0.ɵɵFactoryTarget.Injectable });
AuthProviderInterceptor.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AuthProviderInterceptor });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AuthProviderInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: PlatformService }]; } });

class AuthProviderService {
    constructor(httpClient, platformService) {
        this.httpClient = httpClient;
        this.platformService = platformService;
    }
    getMe() {
        return this.httpClient.get('https://graph.microsoft.com/v1.0/me');
    }
    revoke() {
        return this.getMe().pipe(switchMap(data => this.platformService.post('revoke', { provider: 'Dynamics', remoteIdentifier: _.get(data, 'id') }, 'AuthDispatcher', false, 0, '')));
    }
}
AuthProviderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AuthProviderService, deps: [{ token: i1$1.HttpClient }, { token: PlatformService }], target: i0.ɵɵFactoryTarget.Injectable });
AuthProviderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AuthProviderService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AuthProviderService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: PlatformService }]; } });

class AuthProviderModule {
}
AuthProviderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AuthProviderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AuthProviderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AuthProviderModule, imports: [CommonModule,
        HttpClientModule] });
AuthProviderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AuthProviderModule, providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthProviderInterceptor, multi: true },
        AuthProviderService
    ], imports: [[
            CommonModule,
            HttpClientModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AuthProviderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [
                        CommonModule,
                        HttpClientModule
                    ],
                    providers: [
                        { provide: HTTP_INTERCEPTORS, useClass: AuthProviderInterceptor, multi: true },
                        AuthProviderService
                    ]
                }]
        }] });

/*
 * Public API Surface of core
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AChildFilter, ACondition, AField, AFilter, AJoin, AObject, AObjectError, AObjectMetadata, AObjectService, APageInfo, ASort, ATable, ATableType, ApiService, ApttusModule, AuthProviderInterceptor, AuthProviderModule, AuthProviderService, CacheService, Configuration, ConfigurationService, FileSizePipe, ImagePipe, JSForceService, MetadataService, Operator, PlatformConstants, PlatformService, RavenErrorHandler, SalesforceUtils, SimpleDate, SoapService, TreeUtils, TruncatePipe, genericRetryStrategy };
